
try {
    var fwhtrk = {
        page: {
            link: "",
            name: "",
            section: "",
            curbsideAvailable: "",
            orderstatus: "",
            warningMessage: "",
            errorMessage: "",
            addedProduct: "",
            removedProduct: "",
            virtualname: "",
            type: "",
            event: {
                storeSearchResults: 0,
                storeClickToCall: 0,
                storeGetDirections: 0,
                warningMessage: 0,
                storeDetails: 0,
                orderNow: 0,
                itemAddedtoBag: 0,
                sandwichFavorited: 0,
                itemViewed: 0,
                sandwichCustomized: 0,
                nutritionalUnitChanged: 0,
                bagViewed: 0,
                itemRemoved: 0,
                purchase: 0,
                orderFavorited: 0,
                errorMessage: 0,
                //favoritesAlert: 0,
                certificateDiscount: 0,
                discount: 0,
                tax: 0,
                vechicleSelected: 0,
                curbsideDelivery: 0,
                curbsideSelected: 0,
                pickup: 0,
                miam: 0,
                cartOpen: 0,
                attemptAccountToDelete: 0,
                MIAMSelected: 0,
                toasted: 0,
                kidsMealContinue: 0,
                kidsMealSelected: 0,
                upsellProductAdded: 0
            },
            user: {
                newAccountSource: "",
                experience: "",
            },
            products: "",
            product: {
                ID: "",
                name: "",
                category: "",
                price: "",
                quantity: "",
            },
        },
        event: {
            promoView: 0,
            homeMenu: 0,
            promoPrimaryCTAClick: 0,
            promoSecndaryCTAClick: 0,
            promoApplied: 0,
            promoError: 0,
            orderRevenue: 0,
            orderTax: 0,
            orderDiscount: 0,
            orderCertificateDiscount: 0,
            startonlineorder: 0,
            itemaddedtobag: 0,
            sandwichCustomized: 0,
            upsellProductAdded: 0,
            restaurantsearchrefined: 0,
            cartContinue: 0,
            errormessage: 0,
            errorMessageMW: 0,
            errorMessageUI: 0,
            promoDetails: 0,
            checkoutstarted: 0,
            clicktocall: 0,
            certsApplied: 0,
            rewardApplied: 0,
            certDiscAmt: 0,
            viewRewards: 0,
            restaurantSelected: 0,
            delivery: 0,
            deliverySearch: 0,
            productPriceUpdate: 0,
            productQuantityUpdate: 0,
            MIAMPriceUpdate: 0,
            ExtrasPriceUpdate: 0,
            updateCart: 0,
            productPriceAdded: 0,
            productQuantityAdded: 0,
            MIAMPriceAdded: 0,
            ExtrasPriceAdded: 0,
            bagviewed: 0,
            ExtrasPriceView: 0,
            MIAMPriceView: 0,
            productQuantityView: 0,
            productPriceView: 0,
            MIAMPricePurchase: 0,
            ExtrasPricePurchase: 0,
            purchase: 0,
            productPriceCheckout: 0,
            productQuantityCheckout: 0,
            MIAMPriceCheckout: 0,
            ExtrasPriceCheckout: 0,
            ExtrasPriceRemove: 0,
            MIAMPriceRemove: 0,
            productQuantityRemove: 0,
            productPriceRemove: 0,
            itemRemoved: 0,
            CYO: 0,
            ComboPriceView: 0,
            ComboPriceCheckout: 0,
            sandwichcustomized: 0,
            ComboPriceRemove: 0,
            ComboPriceUpdate: 0,
            dealApplied: 0,
            rewardPoints: 0,
            rewardPrice: 0,
            dealRedeemed: 0
        },
        user: {
            guestID: "n/a",
            loyaltyID: "n/a",
            uxRendered: "",
            billingZip: "",
            geoSelected: "no",
            promo: "",
            loyaltyActiveFlag: "n/a",
            emailOptIn: "n/a",
            tierLevel: "n/a",
        },
        storeSearchKeyword: "n/a",
        offerID: "",
        storeSearchNumber: "",
        storeSearchFilters: "",
        itemFavoritedOrderID: "",
        itemFavoritedProductID: "",
        storeID: "n/a",
        localTime: "", //Browser based time (month-day-year|hour-minutes) (time  24Hrs)
        orderType: "n/a",
        DBFavoritesOrBestsellers: "n/a",
        itemPrice: "",
        itemUnits: "",
        guestCountry: "n/a",
        ConsumerPrice: "",
        offerDesc: "",
        orderValue: "",
        cartID: "",
        //addSource: '',
        //nutritionalUnitSet: '',
        paymentMethod: "",
        currency: "",
        itemFavoritedID: "",
        orderSourceType: "",
        tax: "",
        discount: "",
        //certificateDiscount: '',
        purchaseID: "",
        certificateApplied: "",
        errorMessage: "",
        storeCountry: "n/a",
        storeRegion: "n/a",
        storeLanguage: "en",
        loginStatus: "logged-out",
        //libraryVersion: '2.0',
        products: "",
        transactionID: "",
        addressSource: "",
        reorder: 0,
        position: 0,
        faqTitle: '',
        rewardName: '',
        product: {
            productBadge: "",
        }
    };

    var productsTemplate = {
        productCategory: "productCategory",
        productName: "productName",
        numberOfUnits: "numberOfUnits",
        totalPrice: "totalPrice",
        event27: "event27",
        event163: "event163",
        event159: "event159",
        event160: "event160",
        event189: "event189",
        event190: "event190",
        event191: "event191",
        event192: "event192",
        event193: "event193",
        event171: "event171",
        event172: "event172",
        event182: "event182",
        event183: "event183",
        event184: "event184",
        eVar33: "eVar33",
        eVar34: "eVar34",
        eVar75: "eVar75",
        eVar76: "eVar76",
        eVar77: "eVar77",
        eVar78: "eVar78",
        eVar79: "eVar79",
        eVar80: "eVar80",
        eVar81: "eVar81",
        eVar82: "eVar82",
        eVar83: "eVar83",
        eVar86: "eVar86",
        eVar65: "eVar65",
        eVar102: "eVar102",
        eVar103: "eVar103",
        eVar104: "eVar104",
        eVar105: "eVar105",
        eVar106: "eVar106",
        eVar107: "eVar107",
        eVar108: "eVar108",
        eVar48: "eVar48",
        eVar47: "eVar47",
        eVar146: "eVar146"
    };

    var productsPRTemplate = {
        productCategory: "productCategory",
        productName: "productName",
        numberOfUnits: "numberOfUnits",
        totalPrice: "totalPrice",
        event27: "event27",
        event163: "event163",
        event159: "event159",
        event160: "event160",
        event189: "event189",
        event190: "event190",
        event191: "event191",
        event192: "event192",
        event193: "event193",
        event171: "event171",
        event172: "event172",
        event182: "event182",
        event183: "event183",
        eVar33: "eVar33",
        eVar34: "eVar34",
        eVar75: "eVar75",
        eVar76: "eVar76",
        eVar77: "eVar77",
        eVar78: "eVar78",
        eVar79: "eVar79",
        eVar80: "eVar80",
        eVar81: "eVar81",
        eVar82: "eVar82",
        eVar83: "eVar83",
        eVar86: "eVar86",
        eVar65: "eVar65",
        eVar102: "eVar102",
        eVar103: "eVar103",
        eVar104: "eVar104",
        eVar105: "eVar105",
        eVar106: "eVar106",
        eVar107: "eVar107",
        eVar108: "eVar108",
        eVar48: "eVar48",
        eVar47: "eVar47",
        eVar146: "eVar146"
    };

    var productsCartTemplate = {
        productCategory: "productCategory",
        productName: "productName",
        numberOfUnits: "numberOfUnits",
        totalPrice: "totalPrice",
        event20: "event20",
        event21: "event21",
        event159: "event159",
        event160: "event160",
        event169: "event169",
        event170: "event170",
        event171: "event171",
        event172: "event172",
        event173: "event173",
        event174: "event174",
        event175: "event175",
        event176: "event176",
        event189: "event189",
        event190: "event190",
        event182: "event182",
        event183: "event183",
        event184: "event184",
        event191: "event191",
        event192: "event192",
        eVar23: "eVar23",
        eVar33: "eVar33",
        eVar34: "eVar34",
        eVar75: "eVar75",
        eVar76: "eVar76",
        eVar77: "eVar77",
        eVar78: "eVar78",
        eVar79: "eVar79",
        eVar80: "eVar80",
        eVar82: "eVar82",
        eVar83: "eVar83",
        eVar65: "eVar65",
        eVar102: "eVar102",
        eVar103: "eVar103",
        eVar104: "eVar104",
        eVar105: "eVar105",
        eVar106: "eVar106",
        eVar107: "eVar107",
        eVar108: "eVar108",
        eVar48: "eVar48",
        eVar47: "eVar47",
        eVar146: "eVar146"
    };

    var comboRemovalCartTemplate = {
        productCategory: "productCategory",
        productName: "productName",
        numberOfUnits: "numberOfUnits",
        totalPrice: "totalPrice",
        event20: "event20",
        event21: "event21",
        event159: "event159",
        event160: "event160",
        event169: "event169",
        event170: "event170",
        event171: "event171",
        event172: "event172",
        event173: "event173",
        event174: "event174",
        event175: "event175",
        event176: "event176",
        event189: "event189",
        event190: "event190",
        event182: "event182",
        event183: "event183",
        event184: "event184",
        event191: "event191",
        event192: "event192",
        eVar23: "eVar23",
        eVar33: "eVar33",
        eVar34: "eVar34",
        eVar75: "eVar75",
        eVar76: "eVar76",
        eVar77: "eVar77",
        eVar78: "eVar78",
        eVar79: "eVar79",
        eVar80: "eVar80",
        eVar82: "eVar82",
        eVar83: "eVar83",
        eVar65: "eVar65",
        eVar102: "eVar102",
        eVar103: "eVar103",
        eVar104: "eVar104",
        eVar105: "eVar105",
        eVar106: "eVar106",
        eVar107: "eVar107",
        eVar108: "eVar108",
        eVar48: "eVar48",
        eVar47: "eVar47",
        eVar146: "eVar146"
    };

    var removeCartTemplate = {
        productCategory: "productCategory",
        productName: "productName",
        numberOfUnits: "numberOfUnits",
        totalPrice: "totalPrice",
        event22: "event22",
        event23: "event23",
        event177: "event177",
        event178: "event178",
        event179: "event179",
        eVar33: "eVar33",
        eVar34: "eVar34",
        eVar75: "eVar75",
        eVar76: "eVar76",
        eVar77: "eVar77",
        eVar78: "eVar78",
        eVar79: "eVar79",
        eVar80: "eVar80",
        eVar82: "eVar82",
        eVar83: "eVar83",
        eVar65: "eVar65",
        eVar102: "eVar102",
        eVar103: "eVar103",
        eVar104: "eVar104",
        eVar105: "eVar105",
        eVar48: "eVar48",
        eVar106: "eVar106",
        eVar107: "eVar107",
        eVar108: "eVar108",
        eVar47: "eVar47",
        eVar146: "eVar146"
    };
    var addedCartTemplate = {
        productCategory: "productCategory",
        productName: "productName",
        numberOfUnits: "numberOfUnitsAdded",
        totalPrice: "itemPrice",
        event20: "event20",
        event21: "event21",
        event171: "event171",
        event172: "event172",
        event173: "event173",
        eVar33: "eVar33",
        eVar34: "eVar34",
        eVar23: "eVar23",
        eVar75: "eVar75",
        eVar76: "eVar76",
        eVar77: "eVar77",
        eVar78: "eVar78",
        eVar79: "eVar79",
        eVar80: "eVar80",
        eVar82: "eVar82",
        eVar83: "eVar83",
        eVar65: "eVar65",
        eVar102: "eVar102",
        eVar103: "eVar103",
        eVar104: "eVar104",
        eVar105: "eVar105",
        eVar48: "eVar48",
        eVar106: "eVar106",
        eVar107: "eVar107",
        eVar108: "eVar108",
        eVar47: "eVar47",
        eVar146: "eVar146"
    };

    var makeItAMealTemplate = {
        productCategory: "productCategory",
        productName: "productName",
        numberOfUnits: "numberOfUnits",
        totalPrice: "totalPrice",
        miam: "miam",
        extras: "extras",
        event20: "event20",
        event21: "event21",
        eVar33: "eVar33",
        eVar34: "eVar34",
        eVar65: "eVar65",
        eVar48: "eVar48",
        eVar47: "eVar47",
        eVar146: "eVar146"
    };

    var productsReOrderCartTemplate = {
        productCategory: "productCategory",
        productName: "productName",
        numberOfUnits: "numberOfUnits",
        totalPrice: "totalPrice",
        event20: "event20",
        event21: "event21",
        event171: "event171",
        event172: "event172",
        event173: "event173",
        eVar23: "eVar23",
        eVar75: "eVar75",
        eVar76: "eVar76",
        eVar77: "eVar77",
        eVar78: "eVar78",
        eVar79: "eVar79",
        eVar80: "eVar80",
        eVar82: "eVar82",
        eVar83: "eVar83",
        eVar65: "eVar65",
        eVar106: "eVar106",
        eVar107: "eVar107",
        eVar102: "eVar102",
        eVar103: "eVar103",
        eVar104: "eVar104",
        eVar105: "eVar105",
        eVar108: "eVar108",
        eVar48: "eVar48",
        eVar47: "eVar47",
        eVar146: "eVar146"
    };

    var newAccountSource = {
        acquistionModal: "Join on Order Confirmation Modal",
        rewardJoinButton: "Join on Order Confirmation Page",
        topNav: "Top Nav on Order Confirmation",
    };

    var ordersourcetype = {
        favoriteOrderCart: "Favorite",
        recentOrderCart: "Re-Order",
        regularCart: "Regular",
    };
    var deliveryError = {
        screenName: "delivery error",
        modal: "modal",
    };

    var addressSource = {
        recentLocation: "Recent Locations",
        manualLocation: "Manual Locations",
    };

    var authenticatedText = "authenticated";
    var isUserLoggedIn = $("#isUserLoggedIn").val();
    var productsNthTemplate = {
        productCategory: "productCategory",
        productName: "productName",
        numberOfUnits: "numberOfUnits",
        totalPrice: "totalPrice",
        totalOrderPrice: "event23",
        totalTaxAmount: "event24",
        totalDiscountAmount: "event25",
        certificateValue: "event26",
    };
    var Items = {
        Name: "",
        Price: 0,
        Quantity: 0,
        Tax: 0,
    };
    var ProductModal = { Items };
    var getConfirmationItem = function (pId) {
        var products = orderViewModel.analyticsCartProducts;
        pId = Number(pId);
        for (var item of products) {
            if (pId == Number(item.productId)) {
                return item;
            }
        }
        return null;
    };
    var buildProductsString = function (
        products,
        certificateDiscount,
        discount,
        taxesTotal,
        orderTotalPrice,
        orderConf
    ) {
        var varsProductsList = [],
            eVarDelimiter = "=",
            eVarSeparator = "|",
            baseItemSeparater = ";";
        const prd_string_template = fwhtrk.storeRegion != 'PR' ? productsTemplate : productsPRTemplate;

        for (var i = 0; i < products.length; i++) {
            var varsItems = [];
            var productName = '', categoryName = ''
            item = products[i];
            var product = getConfirmationItem(item.ProductId);
            if (item.Analytics.hasOwnProperty('productName')) {
                productName = formatProductName(item.Analytics.productName);
                categoryName = item.categoryName || item.Analytics.categoryName || "";
            } else {
                productName = formatProductName(product.productName);
                categoryName = product.categoryName || "";
            }
            var extrasPrice = getExtrasPrice(item.Options)
            var mealItem = item.IsMeal ? item.Combo : {}
            var mealPrice = item.IsMeal ? ((parseFloat(item.MakeItAMealPrice) + getUpchargePrice(mealItem.items)) * item.Quantity).toFixed(2) : '0'
            for (var pKey in prd_string_template) {
                switch (prd_string_template[pKey]) {
                    case "productCategory":
                        productString = categoryName + baseItemSeparater;
                        break;
                    case "productName":
                        productString = filterProductName(productName.replace(/,/gi, "/")) + baseItemSeparater;
                        break;
                    case "numberOfUnits":
                        productString = item.Quantity + baseItemSeparater;
                        break;
                    case "totalPrice":
                        productString =
                            parseFloat(item.TotalLineItemPrice).toFixed(2) +
                            baseItemSeparater;
                        break;
                    case "event27":
                        productString =
                            prd_string_template[pKey] +
                            eVarDelimiter +
                            parseFloat(item.TotalLineItemPrice).toFixed(2) +
                            eVarSeparator;
                        break;
                    case "event163":
                        productString =
                            prd_string_template[pKey] +
                            eVarDelimiter +
                            parseFloat(item.TotalLineItemPrice).toFixed(2) +
                            eVarSeparator;
                        break;
                    case "event191":
                        fwhtrk.storeRegion == 'PR' ?
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "0" + eVarSeparator :
                            productString = productsCartTemplate[pKey] + eVarDelimiter + mealPrice + eVarSeparator;
                        break;
                    case "event192":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + (extrasPrice ? (extrasPrice * item.Quantity).toFixed(2) : '0') + eVarSeparator;
                        break;
                    case "event193": //PR Combo price
                        fwhtrk.storeRegion == 'PR' ?
                            productString = prd_string_template[pKey] + eVarDelimiter + mealPrice + baseItemSeparater :
                            productString = prd_string_template[pKey] + eVarDelimiter + "0" + baseItemSeparater;
                        break;
                    case "eVar33":
                        if (categoryName.toLowerCase().indexOf('quick add') >= 0 || item.Analytics.categoryName == "Upsell" || categoryName == "Ajouts Rapides")
                            productString = productsCartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator;
                        else productString = ''
                        break;
                    case "eVar34":
                        if (categoryName.toLowerCase().indexOf('quick add') >= 0 || item.Analytics.categoryName == "Upsell" || categoryName == "Ajouts Rapides")
                            productString = productsCartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator;
                        else productString = ''
                        break;
                    case "eVar75": //protein
                        if (item.Options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(item.Options, "Protein"), "PROTEIN") + eVarSeparator;
                        } else {
                            productString = eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar76": //cheese
                        if (item.Options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(item.Options, "Cheese")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar77": //veggies
                        if (item.Options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(item.Options, "Vegetable")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar78": //sauces
                        if (item.Options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(item.Options, "Sauce")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar79": //seasonigs
                        if (item.Options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(item.Options, "Seasonings")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar80": //bread Name
                        if (item.Options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(item.Options, "Bread"),
                                    "BREAD"
                                ).replace(/, /gi, "/") +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar82": //size
                        if (item.Options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSizeName(item.ProductName.toLowerCase()) +
                                eVarSeparator;
                        }
                        break;
                    case "eVar83": //toasted
                        if (item.Options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getBreadOption(getCartIngredient(item.Options, "Bread")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar86":
                        var option = item.Options.map(function (elem) {
                            return elem.OptionName.split('+')[0].trim();
                        }).join("_");
                        if (option)
                            productString = prd_string_template[pKey] + eVarDelimiter + option.replace(/, /gi, "/") + eVarSeparator;
                        else productString = prd_string_template[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        break;
                    case "eVar65":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + (item.Analytics.ProductOriginSource ? item.Analytics.ProductOriginSource.toLowerCase() : '') + eVarSeparator;
                        break;
                    case "eVar102": //PR eggs
                        if (item.Options) {
                            productString =
                                prd_string_template[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(item.Options, "Egg"),
                                    "EGG"
                                ) +
                                eVarSeparator;
                        } else {
                            productString =
                                prd_string_template[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar103": //PR side of toast
                        if (item.Options) {
                            isPasta = getSectionData(getCartIngredient(item.Options, "Pasta"), "PASTA")
                        } else {
                            isPasta = "n/a";
                        }
                        if (item.Options && isPasta != "n/a") {
                            productString =
                                prd_string_template[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(item.Options, "Bread"),
                                    "BREAD"
                                ).replace(/, /gi, "/") +
                                eVarSeparator;
                        } else {
                            productString =
                                prd_string_template[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar104": //PR pasta type
                        if (item.Options) {
                            productString =
                                prd_string_template[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(item.Options, "Pasta"),
                                    "PASTA"
                                ) +
                                eVarSeparator;
                        } else {
                            productString =
                                prd_string_template[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar105": //PR combo drinks side1 side2
                        if (fwhtrk.storeRegion == "PR") {
                            const ui_source = item.Analytics && item.Analytics.ComboOriginSource ?
                                (":" + item.Analytics.ComboOriginSource) : "";
                            productString = prd_string_template[pKey] + eVarDelimiter +
                                getComboString(mealItem) + `${ui_source}`
                                + eVarSeparator
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator
                        }
                        break;
                    case "eVar106"://selected drink names
                        fwhtrk.storeRegion == 'PR' ?
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator :
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSelectedSideDrinkNames(mealItem.items) + eVarSeparator;
                        break;
                    case "eVar107": //selected extras names
                        productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Extra"), "Extras") + eVarSeparator
                        break;
                    case "eVar108": //PR flavor_newIngredient1_newIngredient2
                        productString = prd_string_template[pKey] + eVarDelimiter +
                            "fl:n/a" + eVarSeparator
                        break;
                    case "eVar48":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a";
                        break;
                    default:
                        productString = "";
                        break;
                }
                if (productString) varsItems.push(productString);
            }
            var itemsString = varsItems.join("");
            varsProductsList.push(itemsString);
        } // looping products items

        fwhtrk.event.orderRevenue = orderTotalPrice;
        fwhtrk.event.orderTax = taxesTotal.toFixed(2);
        fwhtrk.event.orderDiscount = discount;
        fwhtrk.event.orderCertificateDiscount = certificateDiscount;

        return varsProductsList.join(",");
    };

    var formatProductName = function (productName) {
        if (productName && isNaN(productName)) {
            return productName.replace(/,/gi, "/").trim();
        }
        return productName;
    };

    var getSectionData = function (options, sectionName) {
        var meatString = "n/a";
        if (options !== undefined && options.length > 0) {
            var arr = options.map((item) => {
                if (sectionName == "BREAD") return item.name.trim();
                else
                    return (
                        item.name.trim() + (item.editOption !== "" ? "-" + item.editOption : "")
                    );
            });
            return arr.join("_");
        }
        return meatString;
    };

    var getCartItem = function (pId, cId) {
        var products = orderViewModel.analyticsCartProducts;
        pId = Number(pId);
        cId = Number(cId);
        for (var item of products) {
            if (pId == Number(item.productId) && cId === Number(item.categoryId)) {
                return item;
            }
        }
        return null;
    };

    var getCartIngredient = function (data, targetedItem) {
        var selectedIngredients = data
            .map((item) => {
                var optionName = item.OptionName || item.optionName || ''
                ingredient = {
                    editOption: "",
                    groupName: item.modifierGrpId || item.ModifierGrpId || item.ModifierGrpName || item.modifierGrpName || "",
                    name: optionName.split('+')[0].trim(),
                    price: item.UnitPrice || item.price || item.Price,
                    optionName: optionName.split('+')[0].trim(),
                    quantity: item.Portion || item.portion || 1,
                    optionId: item.optionId || item .OptionId || ''
                };
                return ingredient;
            })
            .filter((item) => item.groupName == targetedItem);
        return selectedIngredients;
    };

    var buildCartString = function (products) {

        var varsProductsList = [],
            eVarDelimiter = "=",
            eVarSeparator = "|",
            baseItemSeparater = ";";

        for (var i = 0; i < products.length; i++) {
            var varsItems = [];
            item = products[i];
            var product = getCartItem(item.ProductId, item.ProductClassGroupId);
            var productDetail = getConfirmationItem(item.ProductId);
            var productName = '', categoryName = '';
            var isItemAnalytics = item.Analytics ? item.Analytics.productName : "";
            if (item.Analytics.hasOwnProperty('productName')) {
                productName = formatProductName(item.Analytics.productName);
            } else {
                productName = productDetail && productDetail.productName ?
                    formatProductName(productDetail.productName) : (isItemAnalytics || formatProductName(item.Name));
            }
            categoryName = (item && item.Analytics && item.Analytics.categoryName ?
                item.Analytics.categoryName : item.CategoryName) || '';
            categoryName = !categoryName && product ? product.categoryName : categoryName;
            if (categoryName == "Upsell" && fwhtrk.storeRegion == "PR") {
                categoryName = item.CategoryName ? item.CategoryName : "Quick Add on";
            }
            var mealItem = item.IsMeal ? item.Meal : {};
            if (typeof (mealItem) == 'string') {
                mealItem = JSON.parse(item.Meal);
            }
            var mealPrice = item.IsMeal ? ((parseFloat(mealItem.MealCurrentPrice) + getUpchargePrice(mealItem.Components)) * item.Quantity).toFixed(2) : '0'
            var extrasPrice = getExtrasPrice(item.Options)

            for (var pKey in productsTemplate) {
                switch (productsTemplate[pKey]) {
                    case "productCategory":
                        productString = categoryName + baseItemSeparater;
                        break;
                    case "productName":
                        productString = filterProductName(productName).replace(/,/gi, "/") + baseItemSeparater;
                        break;
                    case "numberOfUnits":
                        productString = item.Quantity + baseItemSeparater;
                        break;
                    case "totalPrice":
                        productString = (parseFloat(item.Price) * parseInt(item.Quantity)).toFixed(2) + baseItemSeparater;
                        break;
                    case "event189":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + (parseFloat(item.Price) * parseInt(item.Quantity)).toFixed(2) + eVarSeparator;
                        break;
                    case "event190":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + item.Quantity + eVarSeparator;
                        break;
                    case "event182":
                        if (fwhtrk.storeRegion == "PR") {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + 0 + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + mealPrice + eVarSeparator;
                        }
                        break;
                    case "event183":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + (extrasPrice ? (extrasPrice * item.Quantity).toFixed(2) : '0') + eVarSeparator;
                        break;
                    case "event184":
                        if (fwhtrk.storeRegion == "PR") {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + mealPrice + baseItemSeparater;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + 0 + baseItemSeparater;
                        }
                        break;
                    case "eVar33":
                        if (categoryName.toLowerCase().indexOf('best seller') >= 0 || categoryName == "Upsell" || categoryName == "Ajouts Rapides" || categoryName == "Quick Add On")
                            productString = productsCartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator;
                        else productString = ''
                        break;
                    case "eVar34":
                        if (categoryName.toLowerCase().indexOf('best seller') >= 0 || categoryName == "Upsell" || categoryName == "Ajouts Rapides" || categoryName == "Quick Add On")
                            productString = productsCartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator;
                        else productString = ''
                        break;
                    case "eVar75": //protein
                        if (item.Options) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Protein"), "PROTEIN") + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar76": //cheese
                        if (item.Options) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Cheese")) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar77": //veggies
                        if (item.Options) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Vegetable")) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar78": //sauces
                        if (item.Options) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Sauce")) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar79": //seasonigs
                        if (item.Options) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Seasonings")) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar80": //bread Name
                        if (item.Options) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Bread"), "BREAD").replace(/, /gi, "/") + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar82": //size
                        if (item.Options) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSizeName(item.Name.toLowerCase()) + eVarSeparator;
                        }
                        break;
                    case "eVar83": //toasted
                        if (item.Options) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getBreadOption(getCartIngredient(item.Options, "Bread")) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar65":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + (item.Analytics.ProductOriginSource ? item.Analytics.ProductOriginSource.toLowerCase() : '') + eVarSeparator;

                        break;

                    case "eVar102": //PR eggs
                        if (item.Options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(item.Options, "Egg"),
                                    "EGG"
                                ) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar103": //PR side of toast
                        if (item.Options) {
                            isPasta = getSectionData(getCartIngredient(item.Options, "Pasta"), "PASTA")
                        } else {
                            isPasta = "n/a";
                        }
                        if (item.Options && isPasta != "n/a") {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(item.Options, "Bread"),
                                    "BREAD"
                                ).replace(/, /gi, "/") +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar104": //PR pasta type
                        if (item.Options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(item.Options, "Pasta"),
                                    "PASTA"
                                ) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar105": //PR combo drinks side1 side2
                        if (fwhtrk.storeRegion == "PR") {
                            const ui_source = item.Analytics && item.Analytics.ComboOriginSource ? (":" + item.Analytics.ComboOriginSource) : "";
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getComboString(mealItem) + `${ui_source}` + eVarSeparator
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter +
                                "n/a" + eVarSeparator
                        }
                        break;
                    case "eVar106"://selected drink names
                        if (fwhtrk.storeRegion == "PR") {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSelectedSideDrinkNames(mealItem.Components) + eVarSeparator
                        }
                        break;
                    case "eVar107": //selected extras names
                        productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Extra"), "Extras") + eVarSeparator
                        break;
                    case "eVar108": //PR flavor_newIngredient1_newIngredient2
                        productString = productsCartTemplate[pKey] + eVarDelimiter +
                            "fl:n/a" + eVarSeparator
                        break;
                    case "eVar48":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a";
                        break;
                    default:
                        productString = "";
                        break;
                }
                if (productString) varsItems.push(productString);
            }
            var itemsString = varsItems.join("");
            varsProductsList.push(itemsString);
        }
        return varsProductsList.join(",");
    };

    var getSelectedSideDrinkNames = function (mealArray = []) {
        const arr = mealArray.map((itr, index) => {
            let option = "";
            if (itr.Options && itr.Options[0]) {
                option = itr.Options[0].OptionName;
            }
            if (itr.options && itr.options[0]) {
                option = itr.options[0].optionName;
            }
            const prefix = (index == 0) ? 'drink-' : 'side-';
            const name = option || itr.Value || itr.ProductName || itr.productName;
            return name ? prefix + name : name;
        })
        return arr.length > 0 ? arr.join('_') +':'+ orderViewModel.OrderSourceType.toLowerCase() : 'n/a'
    }

    var getUpchargePrice = function (mealArray = []) {
        let price = 0;
        mealArray.forEach(itr => {
            price = price + (parseFloat(itr.UpCharge) || parseFloat(itr.Upcharge) || parseFloat(itr.upcharge) || 0)
        })
        return price;
    }

    var getMealRemoveProduct = function (
        categoryName,
        productName,
        size,
        quantity,
        price,
        source,
        productsArray,
        addToBagSource

    ) {
        var varsProductsList = [],
            eVarDelimiter = "=",
            eVarSeparator = "|",
            baseItemSeparator = ";";
        var extrasPrice = getExtrasPrice(productsArray)
        var varsItems = [];
        for (var pKey in productsCartTemplate) {
            if (productsCartTemplate.hasOwnProperty(pKey)) {
                var productString;
                switch (productsCartTemplate[pKey]) {
                    case "productCategory":

                        productString = categoryName + baseItemSeparator;
                        break;
                    case "productName":
                        productString = filterProductName(productName) + baseItemSeparator;
                        break;
                    case "numberOfUnits":
                        productString = quantity + baseItemSeparator;
                        break;
                    case "totalPrice":
                        productString = parseFloat(price).toFixed(2) + baseItemSeparator;
                        break;
                    case "event169":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + parseFloat(price).toFixed(2) + eVarSeparator;
                        break;
                    case "event170":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + quantity + eVarSeparator;
                        break;
                    case "event174":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + '0' + eVarSeparator;
                        break;
                    case "event175":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + (extrasPrice ? (extrasPrice * quantity).toFixed(2) : '0') + baseItemSeparator;
                        break;
                    case "eVar23":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + addToBagSource + eVarSeparator;
                        break;
                    case "eVar75": //protein
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Protein"), "PROTEIN") + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar76": //cheese
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Cheese")) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar77": //veggies
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Vegetable")) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar78": //sauces
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Sauce")) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar79": //seasonigs
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Seasonings")) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar80": //bread Name
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Bread"), "BREAD") + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar82": //size
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + size + eVarSeparator;
                        }
                        break;
                    case "eVar83": //toasted
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getBreadOption(getCartIngredient(item.Options, "Bread")) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar65":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + source + eVarSeparator;
                        break;
                    case "eVar106": //selected drink names
                        productString = productsCartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator
                        break;
                    case "eVar107": //selected extras names
                        productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(item.Options, "Extra"), "Extras") + eVarSeparator

                        break;
                    case "eVar48":
                        if (orderViewModel.subCategory) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + orderViewModel.subCategory;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a";
                        }
                        break;
                    default:
                        productString = "";
                        break;
                }
                if (productString) varsItems.push(productString);
            }
        }
        var itemsString = varsItems.join("");
        varsProductsList.push(itemsString);
        return varsProductsList.join(",");
    };

    var getComboRemoveProduct = function (
        categoryName,
        productName,
        size,
        quantity,
        price,
        source,
        productsArray,
        addToBagSource

    ) {
        var varsProductsList = [],
            eVarDelimiter = "=",
            eVarSeparator = "|",
            baseItemSeparator = ";";
        var extrasPrice = getExtrasPrice(productsArray)
        var varsItems = [];
        const mealItem = item.IsMeal ? item.Meal : {};
        if (typeof (mealItem) == 'string') {
            mealItem = JSON.parse(item.Meal);
        }
        for (var pKey in comboRemovalCartTemplate) {
            if (comboRemovalCartTemplate.hasOwnProperty(pKey)) {
                var productString;
                switch (comboRemovalCartTemplate[pKey]) {
                    case "productCategory":

                        productString = categoryName + baseItemSeparator;
                        break;
                    case "productName":
                        productString = filterProductName(productName) + baseItemSeparator;
                        break;
                    case "numberOfUnits":
                        productString = quantity + baseItemSeparator;
                        break;
                    case "totalPrice":
                        productString = parseFloat(price).toFixed(2) + baseItemSeparator;
                        break;
                    case "event169":
                        productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + parseFloat(price).toFixed(2) + eVarSeparator;
                        break;
                    case "event170":
                        productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + quantity + eVarSeparator;
                        break;
                    case "event174":
                        productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + '0' + eVarSeparator;
                        break;
                    case "event175":
                        productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + (extrasPrice ? (extrasPrice * quantity).toFixed(2) : '0') + eVarSeparator;
                        break;
                    case "eVar23":
                        productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + addToBagSource + eVarSeparator;
                        break;
                    case "eVar75": //protein
                        if (productsArray) {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(productsArray, "Protein"), "PROTEIN") + eVarSeparator;
                        } else {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar76": //cheese
                        if (productsArray) {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(productsArray, "Cheese")) + eVarSeparator;
                        } else {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar77": //veggies
                        if (productsArray) {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(productsArray, "Vegetable")) + eVarSeparator;
                        } else {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar78": //sauces
                        if (productsArray) {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(productsArray, "Sauce")) + eVarSeparator;
                        } else {
                            productString = comboRemovalCartTemplate[pKey] + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar79": //seasonigs
                        if (productsArray) {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(productsArray, "Seasonings")) + eVarSeparator;
                        } else {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar80": //bread Name
                        if (productsArray) {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(productsArray, "Bread"), "BREAD") + eVarSeparator;
                        } else {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar82": //size
                        if (productsArray) {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + size + eVarSeparator;
                        }
                        break;
                    case "eVar83": //toasted
                        if (productsArray) {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + getBreadOption(getCartIngredient(productsArray, "Bread")) + eVarSeparator;
                        } else {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar65":
                        productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + source + eVarSeparator;
                        break;
                    case "eVar106": //selected drink names
                        productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator
                        break;
                    case "eVar107": //selected extras names
                        productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(productsArray, "Extra"), "Extras") + eVarSeparator

                        break;
                    case "eVar48":
                        if (orderViewModel.subCategory) {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + orderViewModel.subCategory;
                        } else {
                            productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + "n/a";
                        }
                        break;
                    case "event176":
                        productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + '0' + baseItemSeparator;
                        break;
                    case "eVar102": //PR eggs
                        if (productsArray) {
                            productString =
                                comboRemovalCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(productsArray, "Egg"),
                                    "EGG"
                                ) +
                                eVarSeparator;
                        } else {
                            productString =
                                comboRemovalCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar103": //PR side of toast
                        if (productsArray) {
                            isPasta = getSectionData(getCartIngredient(productsArray, "Pasta"), "PASTA")
                        } else {
                            isPasta = "n/a";
                        }
                        if (productsArray && isPasta != "n/a") {
                            productString =
                                comboRemovalCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(productsArray, "Bread"),
                                    "BREAD"
                                ).replace(/, /gi, "/") +
                                eVarSeparator;
                        } else {
                            productString =
                                comboRemovalCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar104": //PR pasta type
                        if (productsArray) {
                            productString =
                                comboRemovalCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(productsArray, "Pasta"),
                                    "PASTA"
                                ) +
                                eVarSeparator;
                        } else {
                            productString =
                                comboRemovalCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar105": //PR combo drinks side1 side2
                        productString = comboRemovalCartTemplate[pKey] + eVarDelimiter + 'n/a:n/a' + eVarSeparator
                        break;
                    case "eVar108": //PR flavor_newIngredient1_newIngredient2
                        productString = comboRemovalCartTemplate[pKey] + eVarDelimiter +
                            "fl:n/a" + eVarSeparator
                        break;
                    default:
                        productString = "";
                        break;
                }
                if (productString) varsItems.push(productString);
            }
        }
        var itemsString = varsItems.join("");
        varsProductsList.push(itemsString);
        return varsProductsList.join(",");
    };

    var getCartProducts = function (
        categoryName,
        productName = '',
        size,
        quantity,
        price,
        source,
        productsArray,
        addToBagSource,
        makeItAMealData = [],
        baseProduct = {},
        comboPrice = 0,
        fromUpdate = false

    ) {
        var varsProductsList = [],
            eVarDelimiter = "=",
            eVarSeparator = "|",
            baseItemSeparator = ";";
        var extrasPrice = getExtrasPrice(productsArray["EXTRAS"], true)
        var mealPrice = comboPrice
        var varsItems = [];
        productName = formatProductName(productName);

        for (var pKey in productsCartTemplate) {
            if (productsCartTemplate.hasOwnProperty(pKey)) {
                var productString;
                switch (productsCartTemplate[pKey]) {
                    case "productCategory":

                        productString = categoryName + baseItemSeparator;
                        break;
                    case "productName":
                        productString = filterProductName(productName) + baseItemSeparator;
                        break;
                    case "numberOfUnits":
                        productString = quantity + baseItemSeparator;
                        break;
                    case "totalPrice":
                        productString = parseFloat(price).toFixed(2) + baseItemSeparator;
                        break;
                    case "event169":
                        if (fromUpdate)
                            productString = productsCartTemplate[pKey] + eVarDelimiter + parseFloat(price).toFixed(2) + eVarSeparator;
                        else productString = ''
                        break;
                    case "event170":
                        if (fromUpdate)
                            productString = productsCartTemplate[pKey] + eVarDelimiter + quantity + eVarSeparator;
                        else productString = ''
                        break;
                    case "event174":
                        if (fromUpdate)
                            productString = productsCartTemplate[pKey] + eVarDelimiter + (makeItAMealData.length > 0 ? mealPrice.toFixed(2) : '0') + eVarSeparator;
                        else productString = ''
                        break;
                    case "event175":
                        if (fromUpdate)
                            productString = productsCartTemplate[pKey] + eVarDelimiter + (extrasPrice ? (extrasPrice * quantity).toFixed(2) : '0') + eVarSeparator;
                        else productString = ''
                        break;
                    case "event176":
                        if (fromUpdate)
                            productString = productsCartTemplate[pKey] + eVarDelimiter + '0' + baseItemSeparator;
                        else productString = ''
                        break;
                    case "event20":
                        if (!fromUpdate)
                            productString = productsCartTemplate[pKey] + eVarDelimiter + parseFloat(price).toFixed(2) + eVarSeparator;
                        else productString = ''
                        break;
                    case "event21":
                        if (!fromUpdate)
                            productString = productsCartTemplate[pKey] + eVarDelimiter + quantity + eVarSeparator;
                        else productString = ''
                        break;
                    case "event171":
                        if (!fromUpdate)
                            productString = productsCartTemplate[pKey] + eVarDelimiter + (makeItAMealData.length > 0 ? mealPrice.toFixed(2) : '0') + eVarSeparator;
                        else productString = ''
                        break;
                    case "event172":
                        if (!fromUpdate)
                            productString = productsCartTemplate[pKey] + eVarDelimiter + (extrasPrice ? (extrasPrice * quantity).toFixed(2) : '0') + eVarSeparator;
                        else productString = ''
                        break;
                    case "event173":
                        if (!fromUpdate)
                            productString = productsCartTemplate[pKey] + eVarDelimiter + '0' + baseItemSeparator;
                        else productString = ''
                        break;
                    case "eVar23":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + addToBagSource + eVarSeparator;
                        break;
                    case "eVar33":
                        if (baseProduct.fromUpsell)
                            productString = productsCartTemplate[pKey] + eVarDelimiter + formatProductName(baseProduct.baseProductName) + eVarSeparator;
                        else productString = ''
                        break;
                    case "eVar34":
                        if (baseProduct.fromUpsell)
                            productString = productsCartTemplate[pKey] + eVarDelimiter + 'pdp upsell carousel' + eVarSeparator;
                        else productString = ''
                        break;
                    case "eVar75": //protein
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(productsArray["PROTEIN"], "PROTEIN") + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar76": //cheese
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(productsArray["CHEESE"]) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar77": //veggies
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(productsArray["VEGGIES"]) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar78": //sauces
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(productsArray["SAUCES"]) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar79": //seasonigs
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(productsArray["SEASONINGS"]) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar80": //bread Name
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(productsArray["BREAD"], "BREAD") + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar82": //size
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + size + eVarSeparator;
                        }
                        break;
                    case "eVar83": //toasted
                        if (productsArray) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getBreadOption(productsArray["BREAD"]) + eVarSeparator;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar65":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + source + eVarSeparator;
                        break;
                    case "eVar102":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator;
                        break;
                    case "eVar103":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator;
                        break;
                    case "eVar104":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator;
                        break;
                    case "eVar105":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator;
                        break;
                    case "eVar106": //selected drink names
                        productString = productsCartTemplate[pKey] + eVarDelimiter + getSelectedSideDrinkNames(makeItAMealData) + eVarSeparator
                        break;
                    case "eVar107": //selected extras names
                        productString = productsCartTemplate[pKey] + eVarDelimiter + getSectionData(productsArray["EXTRAS"]) + eVarSeparator
                        break;
                    case "eVar108":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + 'fl:n/a' + eVarSeparator
                        break;
                    case "eVar48":
                        if (orderViewModel.subCategory) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + orderViewModel.subCategory;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a";
                        }
                        break;
                    default:
                        productString = "";
                        break;
                }
                if (productString) varsItems.push(productString);
            }
        }
        var itemsString = varsItems.join("");
        varsProductsList.push(itemsString);
        return varsProductsList.join(",");
    };

    var getBreadOption = function (options) {
        if (options !== undefined && options.length > 0) {
            return options[0].optionName || options[0].editOption || 'n/a';
        }
        return "n/a";
    };

    var getReOrderCartProducts = function (
        categoryName,
        productName = '',
        quantity,
        price,
        addToBagSource,
        productId,
        categoryId,
        prdSizeName = '',
        options,
        combo,
        soupSize,
        subCategory='n/a'
    ) {
        var varsProductsList = [],
            eVarDelimiter = "=",
            eVarSeparator = "|",
            baseItemSeparator = ";";
        var varsItems = [];
        var product = getCartItem(productId, categoryId);
        var prdName = ''
        if (product) {
            prdName = formatProductName(product.productName);
        } else {
            prdName = formatProductName(productName);
        }
        for (var pKey in productsReOrderCartTemplate) {
            if (productsReOrderCartTemplate.hasOwnProperty(pKey)) {
                var productString;
                switch (productsReOrderCartTemplate[pKey]) {
                    case "productCategory":
                        if (product) {
                            productString = formatProductName(product.categoryName) + baseItemSeparator;
                        } else {
                            productString = formatProductName(categoryName) + baseItemSeparator;
                        }
                        break;
                    case "productName":
                        productString = filterProductName(productName.replace(/, /gi, "/")) + baseItemSeparator;
                        break;
                    case "numberOfUnits":
                        productString = quantity + baseItemSeparator;
                        break;
                    case "totalPrice":
                        productString =
                            parseFloat(price).toFixed(2) +
                            baseItemSeparator;
                        break;
                    case "event20":
                        productString =
                            productsCartTemplate[pKey] +
                            eVarDelimiter +
                            parseFloat(price).toFixed(2) +
                            eVarSeparator;
                        break;
                    case "event21":
                        productString =
                            productsCartTemplate[pKey] +
                            eVarDelimiter +
                            quantity +
                            eVarSeparator;
                        break;
                    case "eVar23":
                        productString =
                            productsCartTemplate[pKey] + eVarDelimiter + addToBagSource + eVarSeparator;
                        break;
                    case "eVar75": //protein
                        if (options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(options, "Protein"),
                                    "PROTEIN"
                                ) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar76": //cheese
                        if (options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Cheese")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar77": //veggies
                        if (options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Vegetable")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar78": //sauces
                        if (options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Sauce")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar79": //seasonigs
                        if (options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Seasonings")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;

                    case "eVar80": //bread Name
                      if (options) {
                        let breadName = getCartIngredient(options, "Bread").
                        filter((val) => (val.optionId !== 'D219') && (val.optionId !== 'D95') && (val.optionId !== 'D938'));    
                        productString =
                          productsCartTemplate[pKey] +
                          eVarDelimiter +
                          getSectionData(breadName, "BREAD")+
                          eVarSeparator;
                     
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar82": //size
                        productString =
                            productsCartTemplate[pKey] +
                            eVarDelimiter +
                            getSizeName(prdSizeName.toLowerCase()) +
                            eVarSeparator;
                        break;
                    case "eVar83": //toasted
                      if (options) {
                        let toastedBread = getCartIngredient(options, "BreadCustomizations").
                        filter((val) => (val.optionId == 'D219') || (val.optionId == 'D95') || (val.optionId == 'D938'));    
                        productString =
                          productsCartTemplate[pKey] +
                          eVarDelimiter +
                          getSectionData(toastedBread, "BreadCustomizations") +        
                          eVarSeparator;
                     
                        }
                        else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar65":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + orderViewModel.OrderSourceType.toLowerCase() + eVarSeparator;
                        break;
                    case "event171": //MIAM is not avaialble for all the regions this should remove in future
                        if (combo != null ) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter +
                                0 + eVarSeparator;
                        }
                        break;
                    case "event172":
                        productString = productsCartTemplate[pKey] + eVarDelimiter +
                            getOptionsPrice(options, quantity) + eVarSeparator;
                        break;
                    case "event173": //combo is now for all the cultures
                        if (combo != null) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter + getComboPrice(combo, quantity) + baseItemSeparator;
                        }
                        break;
                    case "eVar102": //PR eggs
                        if (options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(options, "Egg"),
                                    "EGG"
                                ) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar103": //PR side of toast
                        if (options) {
                            isPasta = getSectionData(getCartIngredient(options, "Pasta"), "PASTA")
                        } else {
                            isPasta = "n/a";
                        }
                        if (options && isPasta != "n/a") {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(options, "Bread"),
                                    "BREAD"
                                ).replace(/, /gi, "/") +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar104": //PR pasta type
                        if (options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(options, "Pasta"),
                                    "PASTA"
                                ) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar105": //combo drinks side1 side2 - this is for all the regions
                        productString = productsCartTemplate[pKey] + eVarDelimiter + getComboString(combo) + eVarSeparator;
                       break;
                    case "eVar108": //PR flavor_newIngredient1_newIngredient2
                        if (options) {
                            productString = productsCartTemplate[pKey] + eVarDelimiter +
                                `fl:${getSectionData(getCartIngredient(options, "Drinks"), "Drink Flavors")}` + eVarSeparator
                        }
                        else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter +
                                "fl:n/a" + eVarSeparator
                        }
                        break;
                    case "eVar106"://selected drink names - MIAM now not available for all regions this should remove
                        productString = productsCartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator
                        break;
                    case "eVar107":
                        let extrasString = [];
                        if (options) {
                            const extras = getCartIngredient(options, "Extra")
                            extras.forEach((item) => {
                                extrasString.push(item.name);
                            });
                        }
                        productString = productsCartTemplate[pKey] + eVarDelimiter +
                            (extrasString.length ? extrasString.join("_") : "n/a") + eVarSeparator;
                        break;
                    case "eVar48":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + subCategory + eVarSeparator;
                        break;
                    case "eVar47":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + productId + eVarSeparator;
                        break;
                    case "eVar146":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + soupSize;
                        break;
                    default:
                        productString = "";
                        break;
                }
                if (productString) varsItems.push(productString);
            }
        }
        var itemsString = varsItems.join("");
        varsProductsList.push(itemsString);
        return varsProductsList.join(",");
    };

    var getCartProductsADD = function (
        categoryName,
        productName = '',
        productNameWithoutSize = '',
        price,
        quantity,
        categoryId,
        productId,
        added,
        quickAddon,
        TotalPrice,
        options = [],
        combo = {},
        source
    ) {
        var varsProductsList = [],
            eVarDelimiter = "=",
            eVarSeparator = "|", catgName = '',
            baseItemSeparater = ";";

        var varsItems = [];

        var cartTemplate = added ? addedCartTemplate : removeCartTemplate;
        if (productId && categoryId) {
            var product = getCartItem(productId, categoryId);
        }
        var prdName = ''
        if (product) {
            prdName = formatProductName(product.productName);
            catgName = product.categoryName;
        } else {
            prdName = formatProductName(productNameWithoutSize);
            catgName = categoryName;
        }
        var extrasPrice = getExtrasPrice(options)
        var mealItem = combo || {}
        var mealPrice = !isEmptyCheck(combo) ? (parseFloat(combo.MealCurrentPrice) + getUpchargePrice(mealItem.Components)).toFixed(2) : '0'

        for (var pKey in cartTemplate) {
            if (cartTemplate.hasOwnProperty(pKey)) {
                var productString;
                switch (cartTemplate[pKey]) {
                    case "productCategory":
                        productString = catgName + baseItemSeparater;
                        break;
                    case "productName":
                        productString = filterProductName(prdName).replace(/,/gi, "/") + baseItemSeparater;
                        break;
                    case "numberOfUnits":
                        productString = "" + baseItemSeparater;
                        break;
                    case "totalPrice":
                        productString = "" + baseItemSeparater;
                        break;
                    case "numberOfUnitsAdded":
                        productString = "1" + baseItemSeparater;
                        break;
                    case "itemPrice":
                        productString = parseFloat(price).toFixed(2) + baseItemSeparater;
                        break;
                    case "event20":
                        productString =
                            cartTemplate[pKey] +
                            eVarDelimiter +
                            parseFloat(price).toFixed(2) +
                            eVarSeparator;

                        break;
                    case "event21":
                        productString =
                            cartTemplate[pKey] + eVarDelimiter + quantity + eVarSeparator;
                        break;
                    case "event22":
                        if (TotalPrice) {
                            productString =
                                cartTemplate[pKey] +
                                eVarDelimiter +
                                parseFloat(TotalPrice).toFixed(2) +
                                eVarSeparator;
                        } else {
                            productString =
                                cartTemplate[pKey] +
                                eVarDelimiter +
                                parseFloat(price).toFixed(2) +
                                eVarSeparator;
                        }
                        break;
                    case "event23":
                        productString = cartTemplate[pKey] + eVarDelimiter + quantity + eVarSeparator;
                        break;
                    case "event171":
                        if (fwhtrk.storeRegion == "PR") {
                            productString = cartTemplate[pKey] + eVarDelimiter + 0 + eVarSeparator;
                        } else {
                            productString = cartTemplate[pKey] + eVarDelimiter + mealPrice + eVarSeparator;
                        }
                        break;
                    case "event172":
                        productString = cartTemplate[pKey] + eVarDelimiter + extrasPrice + eVarSeparator;
                        break;
                    case "event173": //PR Combo price
                        if (fwhtrk.storeRegion == "PR") {
                            productString = productsCartTemplate[pKey] + eVarDelimiter +
                                mealPrice + baseItemSeparater;
                        } else {
                            productString = productsCartTemplate[pKey] + eVarDelimiter +
                                0 + baseItemSeparater;
                        }
                        break;
                    case "eVar23":
                        if (quickAddon) {
                            productString =
                                cartTemplate[pKey] + eVarDelimiter + "cart quick-add ons" + eVarSeparator;
                        } else {
                            productString =
                                cartTemplate[pKey] + eVarDelimiter + "cart quantity increase" + eVarSeparator;
                        }
                        break;
                    case "eVar33":
                        if (catgName.toLowerCase().indexOf('quick add') >= 0 || catgName.toLowerCase() == "upsell" || catgName == "Ajouts Rapides")
                            productString = cartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator;
                        else productString = ''
                        break;
                    case "eVar34":
                        if (catgName.toLowerCase().indexOf('quick add') >= 0 || catgName.toLowerCase() == "upsell" || catgName == "Ajouts Rapides")
                            productString = cartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator;
                        else productString = ''
                        break;
                    case "eVar75": //protein
                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Protein"), "PROTEIN") + eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar76": //cheese
                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Cheese")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar77": //veggies
                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Vegetable")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar78": //sauces
                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Sauce")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar79": //seasonigs
                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Seasonings")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar80": //bread Name

                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(options, "Bread"),
                                    "BREAD"
                                ).replace(/, /gi, "/") +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar82": //size
                        if (options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSizeName(productName.toLowerCase()) +
                                eVarSeparator;
                        }
                        break;
                    case "eVar83": //toasted
                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getBreadOption(getCartIngredient(options, "Bread")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar65":
                        const sourceType = source ? source : (orderViewModel.OrderSourceType.toLowerCase());
                        productString = cartTemplate[pKey] + eVarDelimiter + sourceType + eVarSeparator;
                        break;
                    case "eVar102": //PR eggs
                        if (options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(options, "Egg"),
                                    "EGG"
                                ) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar103": //PR side of toast
                        if (options) {
                            isPasta = getSectionData(getCartIngredient(options, "Pasta"), "PASTA")
                        } else {
                            isPasta = "n/a";
                        }
                        if (options && isPasta != "n/a") {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(options, "Bread"),
                                    "BREAD"
                                ).replace(/, /gi, "/") +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar104": //PR pasta type
                        if (options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(options, "Pasta"),
                                    "PASTA"
                                ) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar105": //PR combo drinks side1 side2
                        if (fwhtrk.storeRegion == "PR") {
                            if (mealItem.Components) {
                                productString = cartTemplate[pKey] + eVarDelimiter + getSelectedSideDrinkNames(mealItem.Components) + ":cart" + eVarSeparator;
                            } else {
                                productString = cartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                            }
                        } else {
                            productString = cartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar48":
                        productString = cartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        break;
                    case "eVar106":
                        if (fwhtrk.storeRegion == "PR") {
                            productString = cartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        } else {
                            if (mealItem.Components) {
                                productString = cartTemplate[pKey] + eVarDelimiter + getSelectedSideDrinkNames(mealItem.Components) + eVarSeparator;
                            } else {
                                productString = cartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                            }
                        }
                        break;
                    case "eVar107":
                        if (getCartIngredient(options, "Extra").length > 0) {
                            productString = cartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(options, "Extra"), "Extras") + eVarSeparator;
                        } else {
                            productString = cartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;

                    case "eVar108": //PR flavor_newIngredient1_newIngredient2
                        productString = productsCartTemplate[pKey] + eVarDelimiter +
                            "fl:n/a";
                        break;
                    default:
                        productString = "";
                        break;
                }
                if (productString) varsItems.push(productString);
            }
        }
        var itemsString = varsItems.join("");
        varsProductsList.push(itemsString);
        return varsProductsList.join(",");
    };

    var getCartProductsRemove = function (
        categoryName,
        productName = '',
        productNameWithoutSize = '',
        price = 0,
        quantity = 0,
        categoryId,
        productId,
        added,
        quickAddon,
        TotalPrice,
        options = [],
        combo = {},
        source = null
    ) {
        var varsProductsList = [],
            eVarDelimiter = "=",
            eVarSeparator = "|", catgName = '',
            baseItemSeparater = ";";
        var varsItems = [];
        var cartTemplate = added ? addedCartTemplate : removeCartTemplate;
        if (productId && categoryId) {
            var product = getCartItem(productId, categoryId);
        }
        var prdName = ''
        if (product) {
            prdName = formatProductName(product.productName);
            catgName = product.categoryName
        } else if (productNameWithoutSize) {
            prdName = formatProductName(productNameWithoutSize);
            catgName = categoryName
        } else {
            prdName = formatProductName(productName);
            catgName = categoryName
        }
        var extrasPrice = getExtrasPrice(options)
        var mealItem = combo || {}
        const mealPrice = getComboPrice(combo, quantity);
        if (categoryName == "Upsell" && fwhtrk.storeRegion == "PR") {
            categoryName = "quick add on";
        }

        for (var pKey in cartTemplate) {
            if (cartTemplate.hasOwnProperty(pKey)) {
                var productString;
                switch (cartTemplate[pKey]) {
                    case "productCategory":
                        if (product && product.categoryName != "Upsell") {
                            productString = product.categoryName + baseItemSeparater;
                        } else {
                            productString = categoryName + baseItemSeparater;
                        }
                        break;
                    case "productName":
                        productString = filterProductName(prdName).replace(/,/gi, "/") + baseItemSeparater;
                        break;
                    case "numberOfUnits":
                        productString = quantity + baseItemSeparater;
                        break;
                    case "numberOfUnitsAdded":
                        productString = quantity + baseItemSeparater;
                        break;
                    case "totalPrice":
                        productString = parseFloat(price).toFixed(2) + baseItemSeparater;
                        break;
                    case "itemPrice":
                        productString = parseFloat(price).toFixed(2) + baseItemSeparater;
                        break;
                    case "event20":
                        productString =
                            cartTemplate[pKey] +
                            eVarDelimiter +
                            (parseFloat(price) * parseInt(quantity)).toFixed(2) +
                            eVarSeparator;
                        break;
                    case "event21":
                        productString =
                            cartTemplate[pKey] +
                            eVarDelimiter +
                            quantity +
                            eVarSeparator;
                        break;
                    case "event22":
                        productString = cartTemplate[pKey] + eVarDelimiter + parseFloat(price).toFixed(2) + eVarSeparator;
                        break;
                    case "event23":
                        productString = cartTemplate[pKey] + eVarDelimiter + quantity + eVarSeparator;
                        break;
                    case "event171":
                        productString = cartTemplate[pKey] + eVarDelimiter + mealPrice + eVarSeparator;
                        break;
                    case "event172":
                        productString = cartTemplate[pKey] + eVarDelimiter + extrasPrice + eVarSeparator;
                        break;
                    case "event173":
                        productString = cartTemplate[pKey] + eVarDelimiter + mealPrice + baseItemSeparater;
                        break;
                    case "event177":
                        if (fwhtrk.storeRegion == "PR") {
                            productString = cartTemplate[pKey] + eVarDelimiter + 0 + eVarSeparator;
                        } else {
                            productString = cartTemplate[pKey] + eVarDelimiter + mealPrice + eVarSeparator;
                        }
                        break;
                    case "event178":
                        productString = cartTemplate[pKey] + eVarDelimiter + extrasPrice + eVarSeparator;
                        break;
                    case "event179":
                        if (fwhtrk.storeRegion == "PR") {
                            productString = cartTemplate[pKey] + eVarDelimiter + mealPrice + baseItemSeparater;
                        } else {
                            productString = cartTemplate[pKey] + eVarDelimiter + 0 + baseItemSeparater;
                        }
                        break;
                    case "eVar23":
                        productString = productsCartTemplate[pKey] + eVarDelimiter + "cart" + eVarSeparator;
                        break;
                    case "eVar33":
                        if (quickAddon || catgName.toLowerCase().indexOf('quick add') >= 0 || catgName.toLowerCase() == "upsell" || catgName == "Ajouts Rapides")
                            productString = productsCartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator;
                        else productString = ''
                        break;
                    case "eVar34":
                        if (quickAddon || catgName.toLowerCase().indexOf('quick add') >= 0 || catgName.toLowerCase() == "upsell" || catgName == "Ajouts Rapides")
                            productString = productsCartTemplate[pKey] + eVarDelimiter + 'n/a' + eVarSeparator;
                        else productString = ''
                        break;
                    case "eVar75": //protein
                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Protein"), "PROTEIN") + eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar76": //cheese
                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Cheese")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar77": //veggies
                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Vegetable")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar78": //sauces
                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Sauce")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar79": //seasonigs
                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(getCartIngredient(options, "Seasonings")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar80": //bread Name
                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(options, "Bread"),
                                    "BREAD"
                                ).replace(/, /gi, "/") +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar82": //size
                        if (options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSizeName(productName.toLowerCase()) +
                                eVarSeparator;
                        }
                        break;
                    case "eVar83": //toasted
                        if (options.length > 0) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getBreadOption(getCartIngredient(options, "Bread")) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar65":
                        const sourceType = source ? source : (orderViewModel.OrderSourceType.toLowerCase());
                        productString = cartTemplate[pKey] + eVarDelimiter + sourceType + eVarSeparator;
                        break;
                    case "eVar102": //PR eggs
                        if (options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(options, "Egg"),
                                    "EGG"
                                ) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar103": //PR side of toast
                        if (options) {
                            isPasta = getSectionData(getCartIngredient(options, "Pasta"), "PASTA")
                        } else {
                            isPasta = "n/a";
                        }
                        if (options && isPasta != "n/a") {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(options, "Bread"),
                                    "BREAD"
                                ).replace(/, /gi, "/") +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar104": //PR pasta type
                        if (options) {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                getSectionData(
                                    getCartIngredient(options, "Pasta"),
                                    "PASTA"
                                ) +
                                eVarSeparator;
                        } else {
                            productString =
                                productsCartTemplate[pKey] +
                                eVarDelimiter +
                                "n/a" +
                                eVarSeparator;
                        }
                        break;
                    case "eVar105": //PR combo drinks side1 side2
                        if (fwhtrk.storeRegion == "PR") {
                            if (mealItem.Components) {
                                productString = cartTemplate[pKey] + eVarDelimiter + getSelectedSideDrinkNames(mealItem.Components) + ":cart" + eVarSeparator;
                            } else {
                                productString = cartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                            }
                        } else {
                            productString = cartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar48":
                        productString = cartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        break;
                    case "eVar106":
                        if (fwhtrk.storeRegion == "PR") {
                            productString = cartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        } else {
                            if (mealItem.Components) {
                                productString = cartTemplate[pKey] + eVarDelimiter + getSelectedSideDrinkNames(mealItem.Components) + eVarSeparator;
                            } else {
                                productString = cartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                            }
                        }
                        break;
                    case "eVar107":
                        if (getCartIngredient(options, "Extra").length > 0) {
                            productString = cartTemplate[pKey] + eVarDelimiter + getSectionData(getCartIngredient(options, "Extra"), "Extras") + eVarSeparator;
                        } else {
                            productString = cartTemplate[pKey] + eVarDelimiter + "n/a" + eVarSeparator;
                        }
                        break;
                    case "eVar108": //PR flavor_newIngredient1_newIngredient2
                        productString = productsCartTemplate[pKey] + eVarDelimiter +
                            "fl:n/a"
                        break;
                    default:
                        productString = "";
                        break;
                }
                if (productString) varsItems.push(productString);
            }
        }
        var itemsString = varsItems.join("");
        varsProductsList.push(itemsString);
        return varsProductsList.join(",");
    };

    var getMIAMString = function (
        miamorextras,
        extraName,
        quantity,
        price,
        productId,
        eVar,
        source
    ) {
        var varsProductsList = [],
            eVarDelimiter = "=",
            eVarSeparator = "|",
            baseItemSeparator = ";";
        var varsItems = [];
        for (var pKey in makeItAMealTemplate) {
            if (makeItAMealTemplate.hasOwnProperty(pKey)) {
                var productString;
                switch (makeItAMealTemplate[pKey]) {
                    case "productCategory":
                        productString = miamorextras + baseItemSeparator;
                        break;
                    case "productName":
                        productString = filterProductName(extraName) + baseItemSeparator;
                        break;
                    case "numberOfUnits":
                        productString = quantity + baseItemSeparator;
                        break;
                    case "totalPrice":
                        productString = parseFloat(price).toFixed(2) + baseItemSeparator;
                        break;
                    case "event20":
                        productString =
                            makeItAMealTemplate[pKey] + eVarDelimiter + price + eVarSeparator;
                        break;
                    case "event21":
                        productString =
                            makeItAMealTemplate[pKey] +
                            eVarDelimiter +
                            quantity +
                            baseItemSeparator;
                        break;
                    case "eVar33":
                        productString =
                            makeItAMealTemplate[pKey] +
                            eVarDelimiter +
                            formatProductName(productId) +
                            eVarSeparator;

                        break;
                    case "eVar34":
                        productString =
                            makeItAMealTemplate[pKey] + eVarDelimiter + eVar + eVarSeparator;
                        break;
                    case "eVar65":
                        productString = makeItAMealTemplate[pKey] + eVarDelimiter + source + eVarSeparator;
                        break;
                    case "eVar48":
                        productString = makeItAMealTemplate[pKey] + eVarDelimiter + "n/a";
                        break;
                    default:
                        productString = "";
                        break;
                }
                if (productString) varsItems.push(productString);
            }
        }
        var itemsString = varsItems.join("");
        varsProductsList.push(itemsString);
        return varsProductsList.join(",");
    };

    var getMIAMStringQuickAddToBag = function (
        miamorextras,
        extraName,
        quantity,
        price,
        productId,
        eVar,
        source
    ) {
        var varsProductsList = [],
            eVarDelimiter = "=",
            eVarSeparator = "|",
            baseItemSeparator = ";";
        var varsItems = [];
        for (var pKey in makeItAMealTemplate) {
            if (makeItAMealTemplate.hasOwnProperty(pKey)) {
                var productString;
                switch (makeItAMealTemplate[pKey]) {
                    case "productCategory":
                        productString = miamorextras + baseItemSeparator;
                        break;
                    case "productName":
                        productString = filterProductName(extraName) + baseItemSeparator;
                        break;
                    case "numberOfUnits":
                        productString = quantity + baseItemSeparator;
                        break;
                    case "totalPrice":
                        productString = parseFloat(price).toFixed(2) + baseItemSeparator;
                        break;
                    case "event20":
                        productString =
                            makeItAMealTemplate[pKey] + eVarDelimiter + price + eVarSeparator;
                        break;
                    case "event21":
                        productString =
                            makeItAMealTemplate[pKey] +
                            eVarDelimiter +
                            quantity +
                            baseItemSeparator;
                        break;
                    case "eVar33":
                        productString =
                            makeItAMealTemplate[pKey] +
                            eVarDelimiter +
                            formatProductName(productId) +
                            eVarSeparator;

                        break;
                    case "eVar34":
                        productString =
                            makeItAMealTemplate[pKey] + eVarDelimiter + eVar;
                        break;
                    default:
                        productString = "";
                        break;
                }
                if (productString) varsItems.push(productString);
            }
        }
        var itemsString = varsItems.join("");
        varsProductsList.push(itemsString);
        return varsProductsList.join(",");
    };

    var getMultipleCartProducts = function (products, source, categoryName) {
        var varsProductsList = [],
            currentItem,
            i = 0;
        if (products != undefined) {
            for (i; i < products.length; i++) {
                currentItem = products[i];
                var productsString = getCartProducts(
                    categoryName,
                    currentItem.productName,
                    "",
                    currentItem.quantity,
                    currentItem.totalLineItemPrice,
                    source
                );
                varsProductsList.push(productsString);
            }
        }
        return varsProductsList.join(",");
    };

    var getMultipleReOrderCartProducts = function (
        products,
        source,
        categoryName,
        currentItemResponse,
        isOrderAgain,
        isCalledFromReOrder
    ) {
        var varsProductsList = [],
            currentItem,
            i = 0;
        if (products != undefined) {
            for (i; i < products.length; i++) {
                currentItem = products[i];
                const productNameItem = currentItemResponse[0].productName ? currentItemResponse[0].productName : currentItemResponse[0].ProductName;
                const productItemPrice = currentItemResponse[0].TotalPrice ? currentItemResponse[0].TotalPrice :currentItemResponse[0].totalLineItemPrice;
                const soupSize = currentItemResponse[0].Analytics.IsSoup ? `soups:${currentItemResponse[0].Analytics.Size}` : "n/a";
                const subCategory = currentItemResponse[0].Analytics.SubCategory ? currentItemResponse[0].Analytics.SubCategory : "n/a";
                if (isCalledFromReOrder) {
                    var productName = isOrderAgain ? currentItemResponse[0].productName : currentItem.analyticsProductName;
                    var productPrice = isOrderAgain ? currentItemResponse[0].totalPrice : (currentItem && currentItem.price);

                    var productsString = getReOrderCartProducts(
                        currentItem.analyticsCategoryName,
                        currentItem.analyticsProductName,
                        currentItem.quantity,
                        productPrice,
                        source,
                        currentItem.analyticsProductId,
                        currentItem.analyticsCategoryId,
                        currentItem.productId || currentItem.productNameWithSize || productName,
                        currentItem.options,
                        currentItem.combo,
                        soupSize,
                        subCategory
                    );
                    varsProductsList.push(productsString);
                }
                if (!isCalledFromReOrder) {
                    var productName = isOrderAgain ? productNameItem : currentItem.AnalyticsProductName;
                    var productPrice = isOrderAgain ? productItemPrice: (currentItem && currentItem.Price);

                    var productsString = getReOrderCartProducts(
                        currentItem.AnalyticsCategoryName,
                        currentItem.AnalyticsProductName,
                        currentItem.Quantity,
                        productPrice,
                        source,
                        currentItem.AnalyticsProductId,
                        currentItem.AnalyticsCategoryId,
                        currentItem.ProductId || currentItem.ProductNameWithSize || productName,
                        currentItem.Options,
                        currentItem.Combo,
                        soupSize,
                        subCategory
                    );
                    varsProductsList.push(productsString);
                }

            }
        }
        return varsProductsList.join(",");
    };

    var getLocalTime = function () {
        var d = new Date(),
            dformat =
                [
                    (d.getMonth() + 1).padLeft(),
                    d.getDate().padLeft(),
                    d.getFullYear(),
                ].join("-") +
                "|" +
                [d.getHours().padLeft(), d.getMinutes().padLeft()].join(":");
        //=> dformat => '06-21-2019|12:12'
        return dformat;
    };

    Number.prototype.padLeft = function (base, chr) {
        var len = String(base || 10).length - String(this).length + 1;
        return len > 0 ? new Array(len).join(chr || "0") + this : this;
    };

    var Analytics = function () {
        var self = this;
        const isCms = document.querySelector('body').classList.contains('cms');

        this.loyaltyAcquisitionModal = {
            joinNow: "joinNow",
            myWayRewardsModal: "myWayRewardsModal",
            orderConf: "orderConf",
        };

        this.orderSourceType = {
            favoriteOrderCart: "Favorite",
            recentOrderCart: "Recent Order",
            regularCart: "Regular",
            bestSellerCart: "best sellers",
            reorder:"reorder",
        };

        this.addToBagSources = {
            productDetailPage: "product details",
            customizerPage: "product details",
            menuFavoritesPage: "menu-favorites",
            recentOrderSubPage: "account-order history",
            orderAgainSource: "dashboard-last order",
            favoriteSubPage: "account-favorites",
            recentOrderHome: "home-last order",
            favoritesHome: "Dashboard-favorites",
            customizer: "customized menu",
            menu: "default menu",
            orderHistory: "order history",
            favorite: "favorite",
            orderManagement: "bag",
            pdpFooter: "pdp footer",
            customizerInterstitial: "customizer interstitial",
            pdpInterstitial: "pdp interstitial",
            pdpcart: "pdp cart",
            customizerExtrasInterstitial: "customizer",
            upsell: "pdp upsell carousel",
            kidsMeal: "pdp kids meal",
        };

        this.checkValue = function (arg) {
            return arg || "";
        };

        this.attemptTrack = function (event) {
            if (window._satellite) {
                _satellite.track(event);
            }
        };

        this.appendPageName = function (name) {
            name = this.checkValue(name);
            if (isUserLoggedIn && fwhtrk.page.name.length > 0) {
                if (this.pageNameEndsWithSegment(authenticatedText)) {
                    this.removePageNameSegment();
                }
            }

        };

        this.appendPageNameIfNotEndingIn = function (name) {
            if (fwhtrk.page != null) {
                if (!fwhtrk.page.name.endsWith(name)) {
                    if (isUserLoggedIn && fwhtrk.page.name.length > 0) {
                        if (this.pageNameEndsWithSegment(authenticatedText)) {
                            this.removePageNameSegment();
                        }
                        fwhtrk.page.name += ":" + name.toLowerCase();
                    } else {
                        fwhtrk.page.name += ":" + name.toLowerCase();
                    }
                }
            }
        };

        this.removePageNameSegment = function () {
            var idx = fwhtrk.page.name.lastIndexOf(":");

            if (idx !== -1) {
                fwhtrk.page.name = fwhtrk.page.name.substring(0, idx);
            }
        };

        this.pageNameEndsWithSegment = function (segment) {
            return fwhtrk.page.name.indexOf(segment) !== -1;
        };

        this.replacePageNameSegment = function (segment) {
            this.removePageNameSegment();
            this.appendPageName(segment);
        };

        this.resetPageName = function () {
            var name = getDomainName() + $("#dtmPageName").val().toLowerCase();

            fwhtrk.page.name = name;
        };

        this.addItemToBag = function (
            categoryName,
            productName,
            size,
            quantity,
            price,
            source,
            buttonText,
            productsArray,
            products
        ) {
            fwhtrk.itemPrice = price;
            fwhtrk.itemUnits = quantity || 1;
            var productsString;
            var addToBagSource = analytics.addToBagSources.productDetailPage;
            if (productsArray !== undefined) {
                productsString = getCartProducts(
                    categoryName,
                    productName,
                    size,
                    quantity,
                    price,
                    source,
                    productsArray,
                    addToBagSource
                );
            } else {
                productsString = getMultipleCartProducts(
                    products,
                    source,
                    categoryName
                );
            }
            fwhtrk.event.itemaddedtobag = 1;
            const breadOption =
                productsArray && getBreadOption(productsArray["BREAD"]);
            if (
                breadOption !== undefined &&
                breadOption !== "n/a" &&
                breadOption !== "Regular"
            )
                fwhtrk.page.event.toasted = 1;
            if (buttonText != undefined) {
                if (isKidsMealProduct()) {
                    fwhtrk.page.link =
                        getDomainName()
                        + ": kids meal" +
                        "|" +
                        "select a side:" +
                        buttonText.toLowerCase();
                } else {
                    fwhtrk.page.link =
                        getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.toLowerCase();
                }
            }
            if (productsString != undefined)
                fwhtrk.page.products = productsString
                    .toLowerCase()
                    .replace(/evar/g, "eVar");
            if (productsString != undefined)
                fwhtrk.products = productsString.toLowerCase().replace(/evar/g, "eVar");
        };

        this.makeitameal = function (
            categoryName,
            productName,
            size,
            quantity,
            price,
            source,
            productsArray,
            productId,
            fromMiam,
            makeItAMealData,
            isApply,
            upsellProducts
        ) {
            var varsProductsList = [];
            fwhtrk.itemPrice = price;
            fwhtrk.itemUnits = 1;
            var addToBagSource = analytics.addToBagSources.productDetailPage;
            var productsString = getCartProducts(
                categoryName,
                productName,
                size,
                quantity,
                price,
                source,
                productsArray,
                addToBagSource
            );
            varsProductsList.push(productsString);

            if (
                Object.keys(productsArray).length !== 0 &&
                productsArray["EXTRAS"] !== undefined &&
                productsArray["EXTRAS"].length > 0
            ) {
                fwhtrk.event.sandwichCustomized = 1;
                productsArray["EXTRAS"].forEach((item) => {
                    addToBagSource =
                        analytics.addToBagSources.customizerExtrasInterstitial;
                    let MIAMString = "";
                    const price = parseFloat(item.price) * quantity || 0;

                    MIAMString = getMIAMString(
                        makeItAMealTemplate.extras,
                        item.name,
                        quantity,
                        price.toFixed(2),
                        productName,
                        addToBagSource,
                        source
                    );

                    if (MIAMString) varsProductsList.push(MIAMString);
                });
            }
            if (upsellProducts.length > 0) {
                fwhtrk.event.upsellProductAdded = 1;
                upsellProducts.forEach((item) => {
                    addToBagSource = analytics.addToBagSources.upsell;
                    let MIAMString = "";
                    const price = parseFloat(item.price) || 0;
                    MIAMString = getMIAMString(
                        "quick add on",
                        item.name,
                        1,
                        price.toFixed(2),
                        productName,
                        addToBagSource,
                        source
                    );

                    if (MIAMString) varsProductsList.push(MIAMString);
                });
            }
            if (fromMiam) {
                var selectedName = [],
                    price = 0,
                    flPrice = 0;
                if (!isKidsMealProduct()) fwhtrk.page.event.MIAMSelected = 1;
                makeItAMealData.forEach((item) => {
                    selectedName.push(
                        item.options !== undefined && item.options.length > 0
                            ? item.options[0].optionName
                            : item.productName
                    );
                    price = parseFloat(item.price) * quantity;
                });
                selectedName = selectedName.join("_");
                var MIAMString = "";
                let templateString = makeItAMealTemplate.miam;
                if (isKidsMealProduct()) {
                    templateString = "kids meal";
                    addToBagSource = analytics.addToBagSources.kidsMeal;
                    fwhtrk.page.event.kidsMealSelected = 1;
                }
                MIAMString = getMIAMString(
                    templateString,
                    selectedName,
                    quantity,
                    price.toFixed(2),
                    productName,
                    addToBagSource,
                    source
                );

                if (MIAMString) varsProductsList.push(MIAMString);
            }

            if (
                (orderViewModel.Analytics.isFooterMIAMSelected ||
                    orderViewModel.Analytics.isMiamYesButtonClicked ||
                    orderViewModel.Analytics.isMiamFromCart ||
                    orderViewModel.Analytics.isMiamFromCustomizer) &&
                !orderViewModel.Analytics.isNoMiamFromCustomizer
            ) {
                var eVar34 = orderViewModel.Analytics.isFooterMIAMSelected
                    ? self.addToBagSources.pdpFooter
                    : orderViewModel.Analytics.isMiamYesButtonClicked
                        ? self.addToBagSources.pdpInterstitial
                        : orderViewModel.Analytics.isMiamFromCart
                            ? self.addToBagSources.pdpcart
                            : self.addToBagSources.customizerInterstitial;
                MIAMString = getMIAMString(
                    makeItAMealTemplate.miam,
                    $("#hdnProductId").val(),
                    comboPrice,
                    comboId,
                    eVar34,
                    source
                );
                if (MIAMString) varsProductsList.push(MIAMString);
            }
            var completeMIAMString = varsProductsList.join(",");
            if (completeMIAMString) {
                fwhtrk.page.products = completeMIAMString
                    .toLowerCase()
                    .replaceAll("evar", "eVar");
                fwhtrk.products = completeMIAMString
                    .toLowerCase()
                    .replaceAll("evar", "eVar");
            }
        };

        this.addtocart_pdp = function (parameters) {
            fwhtrk.itemPrice = parameters.price;
            fwhtrk.itemUnits = parameters.quantity || 1;

            if (parameters.fromUpdate) {
                fwhtrk.event.productPriceUpdate = 1
                fwhtrk.event.productQuantityUpdate = 1
                fwhtrk.event.MIAMPriceUpdate = 1
                fwhtrk.event.ExtrasPriceUpdate = 1
                fwhtrk.event.updateCart = 1
                fwhtrk.page.event.MIAMSelected = 0
                fwhtrk.event.ComboPriceUpdate = 1
            } else {
                fwhtrk.event.productPriceAdded = 1
                fwhtrk.event.productQuantityAdded = 1
                fwhtrk.event.MIAMPriceAdded = 1
                fwhtrk.event.ExtrasPriceAdded = 1
                fwhtrk.event.itemaddedtobag = 1;
                fwhtrk.event.ComboPriceAdded = 1;
            }
            const breadOption = parameters.pdp_data && getBreadOption(parameters.pdp_data["BREAD"]);
            if (breadOption && breadOption.indexOf('Toasted') >= 0)
                fwhtrk.page.event.toasted = 1;
            if (parameters.buttonText) {
                if (isKidsMealProduct()) {
                    fwhtrk.page.link = getDomainName() + ":kids meal" + "|" + "select a side:" + parameters.buttonText.toLowerCase();
                } else {
                    fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + parameters.buttonText.toLowerCase();
                }
            }
            var productsString = '';
            var addToBagSource = analytics.addToBagSources.productDetailPage;
            if (parameters.productCustimized) {
                fwhtrk.event.sandwichCustomized = 1;
                addToBagSource = 'customizer'
            }
            if (parameters.pdp_data !== undefined) {
                productsString = getCartProducts(parameters.categoryName, parameters.productName.trim(), parameters.size,
                    parameters.quantity, parameters.price, parameters.sourceType,
                    parameters.pdp_data, addToBagSource, parameters.makeItAMealData, parameters.upsellProducts, parameters.comboBundlePrice, parameters.fromUpdate);
            }

            if (isKidsMealProduct()) {
                fwhtrk.page.event.kidsMealSelected = 1;
            }
            if (!isKidsMealProduct() && parameters.fromMiam) fwhtrk.page.event.MIAMSelected = 1;
            var upsellString = []
            if (parameters.upsellProducts.length > 0) {
                fwhtrk.event.upsellProductAdded = 1;
                const quickaddon = orderViewModel.headerFooterLanguageCode === "fr-CA" ? "Ajouts Rapides" : "quick add on"
                parameters.upsellProducts.forEach((itr) => {
                    var productsString1 = getCartProducts(quickaddon, itr.name, 'n/a', itr.quantity, itr.price, parameters.sourceType, [], analytics.addToBagSources.productDetailPage, [], { "fromUpsell": true, "baseProductName": parameters.productName });
                    upsellString.push(productsString1)
                })
                const finalstring = upsellString.join(',')
                productsString = productsString + "," + finalstring
            }

            fwhtrk.page.products = productsString.toLowerCase().replace(/evar/g, "eVar");
            fwhtrk.products = productsString.toLowerCase().replace(/evar/g, "eVar");
        }

        this.removeMeal = function (productsArray, categoryName, productName, quantity, price, productNameWithSize) {
            fwhtrk.event.productPriceUpdate = 1
            fwhtrk.event.productQuantityUpdate = 1
            fwhtrk.event.MIAMPriceUpdate = 1
            fwhtrk.event.ExtrasPriceUpdate = 1
            fwhtrk.event.updateCart = 1
            fwhtrk.page.event.MIAMSelected = 0
            fwhtrk.event.ComboPriceUpdate = 1;
            let removeMIAM = 'remove miam';
            if (fwhtrk.storeRegion == 'PR') {
                removeMIAM = 'remove combo';
            }
            fwhtrk.page.link = fwhtrk.page.section + "|" + removeMIAM;
            var productsString = fwhtrk.storeRegion != 'PR' ?
                getMealRemoveProduct(categoryName, productName, getSizeName(productNameWithSize), quantity, price, orderViewModel.OrderSourceType.toLowerCase(), productsArray, 'n/a') :
                getComboRemoveProduct(categoryName, productName, getSizeName(productNameWithSize), quantity, price, orderViewModel.OrderSourceType.toLowerCase(), productsArray, 'n/a');
            fwhtrk.page.products = productsString.toLowerCase().replace(/evar/g, "eVar");
            fwhtrk.products = productsString.toLowerCase().replace(/evar/g, "eVar");
            this.attemptTrack('updateToCart')
        }
        this.favoriteItem = function (productId) {
            fwhtrk.page.event.sandwichFavorited = 1;
        };

        this.recordError = function (errName, errMessage) {
            //fwhtrk.page.event.errorMessage = 1;

            if (!errName) {
                errName = $("#error-title").data("fallbackErrorTitle");
            }

            if (!errMessage) {
                errMessage = $("#error-body").data("fallbackErrorBody");
            }
            //fwhtrk.errorMessage = errName + ': ' + errMessage;
            this.attemptTrack("errorMessage");
        };

        this.recordFavoritesError = function (errName, errMessage) {
            //fwhtrk.page.event.favoritesAlert = 1;
            this.recordError(errName, errMessage);
            this.attemptTrack("favoritesAlert");
        };

        this.setPickupTime = function () {
            this.resetPageName();
            this.appendPageName("schedule pickup");
            this.attemptTrack("schedulePickup");
        };

        this.recordOrderError = function (errName, errMessage) {
            this.recordError(errName, errMessage);
            fwhtrk.page.name = getDomainName() + ":bag:issue placing order";
            this.attemptTrack("orderissue");
        };

        this.recordTooManyItemsError = function (errName, errMessage) {
            this.resetPageName();
            this.appendPageName(getDomainName() + ":bag:need bigger bag");
            this.recordError(errName, errMessage);
            this.attemptTrack("biggerBag");
        };

        this.itemCustomized = function (productId, productName) {
            fwhtrk.page.event.sandwichCustomized = 1;

            this.appendPageName(productName);
            this.appendPageName("customize");
        };

        this.appendFilter = function (filter) {
            fwhtrk.storeSearchFilters = filter;
        };

        var lastKeywordSearched;
        //let filterKeys = "";
        this.locatorSearch = function (keyword, numResults, filters) {
            //if (keyword === lastKeywordSearched) {
            //    return;
            //}

            this.appendPageNameIfNotEndingIn("results");
            if (fwhtrk.page != null) {
                fwhtrk.page.event.storeSearchResults = 1;
            }
            fwhtrk.storeSearchKeyword = keyword;
            fwhtrk.storeSearchNumber = numResults;

            var i = 0;
            var len = (filters && filters.length) || 0;
            let filterKeys = "";
            //for (; i < len; i += 1) {
            //    if (len > 0) {
            //        filterKeys += filters[i] + ",";
            //    }
            //    else {
            //        filterKeys += filters[i];
            //    }
            //}
            var arr = filters.map((item) => {
                return item;
            });
            filterKeys = arr.join(",");
            this.appendFilter(filterKeys);
            lastKeywordSearched = keyword;

            this.attemptTrack("storeSearchResults");
        };

        this.locatorCallStore = function (storeId) {
            this.appendPageNameIfNotEndingIn("results");

            fwhtrk.page.event.storeClickToCall = 1;
            fwhtrk.storeID = storeId;

            this.attemptTrack("storeClickToCall");
        };

        //this.locatorGetDirections = function (storeId) {
        //    this.appendPageNameIfNotEndingIn('results');

        //    fwhtrk.page.event.storeGetDirections = 1;
        //    fwhtrk.storeID = storeId;

        //    this.attemptTrack('storeGetDirections');
        //};

        this.locatorStoreDetails = function (storeId) {
            this.appendPageNameIfNotEndingIn("results");

            fwhtrk.page.event.storeDetails = 1;
            fwhtrk.storeID = storeId;

            this.attemptTrack("storeDetails");
        };

        this.locatorIndividualOrder = function (storeId) {
            this.appendPageNameIfNotEndingIn("results");

            fwhtrk.page.event.orderNow = 1;
            fwhtrk.storeID = storeId;
            fwhtrk.orderType = "individual";

            this.attemptTrack("storeOrderOnline");
        };

        this.locatorCateringOrder = function (storeId) {
            this.appendPageNameIfNotEndingIn("results");

            fwhtrk.page.event.orderNow = 1;
            fwhtrk.storeID = storeId;
            fwhtrk.orderType = "catering";

            this.attemptTrack("storeCatering");
        };

        this.startOrContinueOrder = function () {
            this.attemptTrack("Nav Click Event Start Order");
        };

        this.addSomethingElse = function (buttonText) {
            fwhtrk.page.link = buttonText;
            this.attemptTrack("addSomethingElse");
        };
        this.loyalErrorHandle = function (message, parentCode = 'n/a', title = '', childCode = 'n/a') {
            fwhtrk.errorMessage = message;
            fwhtrk.event.errorMessage = 1;
            fwhtrk.parentErrorCode = parentCode ? parentCode : "n/a";
            fwhtrk.childErrorCode = childCode ? childCode : "n/a";
            fwhtrk.event.errorMessageMW = 1;
            fwhtrk.event.errorMessageUI = 0;
            fwhtrk.page.virtualname = fwhtrk.page.name + ':' + "error modal";
            this.attemptTrack("errorMessage");
        };
        this.errorModalClose = function () {
            fwhtrk.page.virtualname = '';
        };
        this.viewRewardsClick = function (buttonText, sourceText) {
            var source = sourceText ? sourceText : "";
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() + "|" + source + buttonText.toLowerCase();
            fwhtrk.event.viewRewards = 1;
            if (buttonText) {
                this.attemptTrack("dashboard_click_action");
            }
            fwhtrk.event.startonlineorder = 0;
        };

        this.cardListClick = function (buttonText, sourceText) {
            var source = sourceText ? sourceText : "";
            var getLink = "";
            if (isCms) {
                getLink = fwhtrk.page.section + "|" + source + buttonText.trim().toLowerCase();
            } else {
                getLink = getDomainName() + $("#dtmPageSection").val() + "|" + source + buttonText.trim().toLowerCase();
            }
            this.closeModal();
            fwhtrk.page.link = getLink;
            if (sourceText && sourceText.toLowerCase() == 'footer:') {
                fwhtrk.event.startonlineorder = 0;
                this.attemptTrack("footer_click_action");
            }
            else if (sourceText && sourceText.toLowerCase() == 'header:') {
                if (buttonText.toLowerCase() == "start order") {
                    fwhtrk.event.startonlineorder = 1;
                }
                else if (buttonText.toLowerCase() == "deals" || buttonText.toLowerCase() == "rewards") {
                    fwhtrk.page.link = fwhtrk.page.section + "|" + source + buttonText.toLowerCase();
                }
                else {
                    fwhtrk.event.startonlineorder = 0;
                }
                this.attemptTrack("header_click_action");
            }
            else if (buttonText) {
                fwhtrk.event.startonlineorder = 0;
                this.attemptTrack("dashboard_click_action");
            }
        };

        this.orderAgainCLickAction = function () {
            fwhtrk.localTime = getLocalTime();
            fwhtrk.reorder = 1;
            fwhtrk.event.startonlineorder = 1;
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + 're-order';
        };

        this.orderAgainFailClickAction = function () {
            this.attemptTrack("dashboard_click_action");
        };

        this.recentOrderClick = function (buttonText, isfav = false) {
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.toLowerCase();
            isfav
                ? (fwhtrk.event.startonlineorder = 0)
                : (fwhtrk.event.startonlineorder = 1);
            this.attemptTrack("recent_order_click_action");
        };

        this.rewardsAndDealNavClick = function (source, buttonText) {
            this.page.link = $("#dtmPageSection").val() + "|" + "header" + buttonText;
            this.attemptTrack("header_click_action");
        };



        this.startNewOrderClick = function (buttonText) {
            fwhtrk.localTime = getLocalTime();
            fwhtrk.event.startonlineorder = 1;
            if (fwhtrk.page.section == getDomainName() + ":home") {
                fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|order status:" + buttonText.toLowerCase();
                this.attemptTrack("dashboard_click_action");
            } else if (isCurrentPage('recent-orders')) {
                fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.toLowerCase();
                this.attemptTrack("recent_order_click_action");
            } else if (isCurrentPage('locator')) {
                fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.toLowerCase();
                this.attemptTrack("locator_click_action");
            } else {
                fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.toLowerCase();
                this.attemptTrack("favorites_click_action");
            }
        };

        this.somethingDifferentClick = function (buttonText, showHeader = true) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + "header:" + buttonText.toLowerCase();
            if (!showHeader) {
                fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.toLowerCase();
            }
            this.attemptTrack("menu_click_action");
        };

        this.goToCheckout = function (buttonText) {
            fwhtrk.page.link = buttonText;
            this.attemptTrack("goToCheckout");
        };

        this.removeItemFromBag = function (productId, price, qty) {
            fwhtrk.page.event.itemRemoved = 1;
            fwhtrk.itemPrice = price;
            fwhtrk.itemUnits = qty;
        };

        this.viewBag = function (productsList) {
            fwhtrk.page.event.bagViewed = 1;
        };
        this.getScreenBreakpoint = function () {
            var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 1024;

            switch (true) {
                case width < 768:
                    return "mobile";

                case width < 992:
                    return "tablet";
                //Ignoring kiosk breakpoint, not sure if relevant
            }

            return "desktop";
        };

        this.orderType = function (orderTypeName, buttonText) {
            if (orderTypeName !== undefined) {
                fwhtrk.orderType = orderTypeName;
            } else if (orderViewModel.Analytics.orderType !== undefined) {
                fwhtrk.orderType = orderViewModel.Analytics.orderType;
            } else {
                fwhtrk.orderType = "n/a";
            }
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.toLowerCase();
            fwhtrk.event.restaurantSelected = orderViewModel.Analytics.restaurantSelected;
            fwhtrk.page.event.pickup = orderViewModel.Analytics.pickup;
        };

        this.anonymousUser = "no id";
        this.fallbackCountrys = "n/a";
        this.fallbackLanguage = "n/a";
        this.fallbackCountry = "n/a";

        this.setBAUGlobalValues = function () {
            var pageName = getDomainName() + $("#dtmPageName").val().toLowerCase();
            var locale = $("#scLanguageCode").val().toLowerCase();
            if (isCurrentPage("miam")) {
                fwhtrk.page.section = isKidsMealProduct()
                    ? getDomainName() + ":kids meal"
                    : getDomainName() + $("#dtmPageSection").val();
                fwhtrk.page.name = isKidsMealProduct()
                    ? getDomainName() + ":" + locale + ":kids meal:select a drink"
                    : pageName + ":select a drink";
            } else {
                fwhtrk.page.name = pageName;
                fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val();
            }
        }

        this.setCMSGlobalValues = function () {
            const url = window.location.href.toLowerCase();
            let source = "";
            let slug = "";
            const urlArray = url.split(/[#?]/)[0].split('/');
            const locale = urlArray[3] || 'n/a';
            const sectionName = urlArray[4] ? urlArray[4].split('?')[0].split('#')[0] : 'home';
            source = urlArray[2].includes('order') ? 'order' : 'subway';
            for (let i = 4; i < urlArray.length; i++) {
                if (urlArray[i]) {
                    if (i == urlArray.length - 1) {
                        slug = slug + ':' + urlArray[i].split('?')[0].split('#')[0];
                    } else {
                        slug = slug + ':' + urlArray[i];
                    }
                }
            }
            if (!slug) {
                slug = ":home"
            }
            const pageName = `${source}:${locale}${slug}`;
            const pageSection = `${source}:${sectionName}`;

            if (isCurrentPage("miam")) {
                fwhtrk.page.section = isKidsMealProduct()
                    ? getDomainName() + ":kids meal"
                    : pageSection;
                fwhtrk.page.name = isKidsMealProduct()
                    ? getDomainName() + ":" + locale + ":kids meal:select a drink"
                    : pageName + ":select a drink";
            } else {
                fwhtrk.page.name = pageName;
                fwhtrk.page.section = pageSection;
            }
        }

        this.setGlobalValues = function () {
            if (isCms) {
                this.setCMSGlobalValues();
            } else {
                this.setBAUGlobalValues();
            }


            if ($("#cmsPage").val() == "true") {
                fwhtrk.user.experience = "order redesign v2";
            } else {
                fwhtrk.user.experience = "order redesign mvp";
            }
            fwhtrk.page.type = $('#isErrorPage').val() === "true" ? "errorPage" : ''
            fwhtrk.user.uxRendered = analytics.getScreenBreakpoint();
            //TODO: this very annoying to the user on every page, We need to change logic to get position based on browser setting
            //navigator.geolocation.getCurrentPosition(function () {
            fwhtrk.user.geoSelected = "yes";
            //}, function () {
            //    fwhtrk.user.geoSelected = 'no';
            //});

            var username = $("#dtmUserName").val();
            var loyaltyId = $("#dtmLoyaltyId").val() || "n/a";
            var guestId = $("#dtmGuestID").val();
            var loyaltyActiveFlag = $('#loyaltyActiveFlag').val();
            var emailOptIn = $('#emailOptIn').val();

            if (isUserLoggedIn) {
                fwhtrk.user.guestID = guestId;
                fwhtrk.user.loyaltyID = loyaltyId;
                fwhtrk.loginStatus = "logged-in";
            } else {
                fwhtrk.user.guestID = "n/a";
                fwhtrk.user.loyaltyID = "n/a";
                fwhtrk.loginStatus = "logged-out";
            }
            fwhtrk.storeID = orderViewModel ? orderViewModel.store.id || orderViewModel.store.StoreId || 'n/a' : 'n/a';
            fwhtrk.orderType = orderViewModel ? orderViewModel.AnalyticsorderType ? orderViewModel.AnalyticsorderType : 'n/a' : 'n/a';
            fwhtrk.guestCountry = orderViewModel ? orderViewModel.Analytics.guestCountry || this.fallbackCountry || 'n/a' : 'n/a';
            fwhtrk.storeCountry = orderViewModel ? orderViewModel.store.storeCountry || this.fallbackCountry : 'n/a';
            if (fwhtrk.storeRegion == "PR") {
                fwhtrk.storeRegion = orderViewModel.store.storeCountry;
            } else {
                fwhtrk.storeRegion = 'n/a';
            }
            fwhtrk.localTime = getLocalTime();
            fwhtrk.storeLanguage = orderViewModel.store.languageCode ? orderViewModel.store.languageCode.substring(0, 2) : 'n/a';
            fwhtrk.user.loyaltyActiveFlag = isUserLoggedIn ? (loyaltyActiveFlag || "n/a") : "n/a";
            fwhtrk.user.emailOptIn = isUserLoggedIn ? (emailOptIn || "n/a") : "n/a";
        };

        this.setStoreIsoCodes = function (selectedCountry) {
            fwhtrk.storeCountry =
                orderViewModel.store.storeCountry || this.fallbackCountry;
            if (orderViewModel.Analytics.guestCountry == "") {
                fwhtrk.guestCountry = selectedCountry || this.fallbackCountrys;
            } else {
                fwhtrk.guestCountry =
                    orderViewModel.Analytics.guestCountry || this.fallbackCountrys;
            }
            fwhtrk.storeRegion = orderViewModel.store.storeCountry == "PR" &&
                orderViewModel.store.storeCountry || this.fallbackCountry;
            if (orderViewModel.Analytics.guestCountry == "") {
                fwhtrk.guestCountry = selectedCountry || this.fallbackCountrys;
            } else {
                fwhtrk.guestCountry =
                    orderViewModel.Analytics.guestCountry || this.fallbackCountrys;
            }
            if (
                orderViewModel != undefined &&
                orderViewModel.AnalyticsorderType != null &&
                orderViewModel.AnalyticsorderType != undefined
            ) {
                fwhtrk.orderType = orderViewModel.AnalyticsorderType;
            }
            if (
                orderViewModel != undefined &&
                orderViewModel.currentOrder != undefined &&
                orderViewModel.currentOrder != null &&
                orderViewModel.currentOrder.cartId != null &&
                orderViewModel.currentOrder.cartId != undefined
            ) {
                fwhtrk.cartID = orderViewModel.currentOrder.cartId;
            }
            if (orderViewModel.store.languageCode != null && orderViewModel.store.id != null) {
                fwhtrk.storeLanguage = orderViewModel.store.languageCode.substring(
                    0,
                    2
                );
                if (fwhtrk.storeLanguage == "sp") {
                    fwhtrk.storeLanguage = "es";
                }
            } else {
                fwhtrk.storeLanguage = this.fallbackLanguage;
            }
        };

        this.setStoreID = function () {
            var currentStore =
                (orderViewModel.store && orderViewModel.store.id) || "n/a";
            fwhtrk.storeID = currentStore;
        };

        this.viewOrderStatusAnalytics = function () {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + "order status:view order status";
            this.attemptTrack("orderStatus_click_action");
        };

        this.checkLoginHistory = function () {
            var username = $("#dtmUserName").val();

            if (username && username !== this.anonymousUser) {
                orderViewModel.hasLoggedIn = true;
                orderViewModel.save();
            }
            else {
                orderViewModel.hasLoggedIn = false;
                orderViewModel.save();
            }
        };
        this.favorite = function (productId, orderId) {
            fwhtrk.page.event.orderFavorited = 1;
            //this.orderConfirmationPageTracking = (orderConfirmationDetails);
            //var orderId = orderConfirmationDetails.orderId;
            fwhtrk.itemFavoritedOrderID = orderId;
            fwhtrk.itemFavoritedProductID = productId;
            this.attemptTrack("item_favorite");
        };
        this.orderString = function (model) {

            var prodCartString = buildCartString(model.Items);
            fwhtrk.products = prodCartString.toLowerCase().replace(/evar/g, "eVar");
            fwhtrk.page.products = prodCartString.toLowerCase().replace(/evar/g, "eVar");
            var prodString = prodCartString.toLowerCase().replace(/evar/g, "eVar");
            fwhtrk.event.productPriceView = 1;
            fwhtrk.event.productQuantityView = 1;
            fwhtrk.event.MIAMPriceView = 1;
            fwhtrk.event.ExtrasPriceView = 1;
            fwhtrk.event.bagviewed = 1;
            fwhtrk.event.ComboPriceView = 1;
            fwhtrk.offerID = model.OfferId ? model.OfferId : "n/a";
            fwhtrk.offerDesc = model.OfferDescription ? model.OfferDescription.toLowerCase() : "n/a";
            if (model.Offers && model.Offers[0] && model.Offers[0].PromoCode) {
                fwhtrk.user.promo = model.Offers[0].PromoCode.toLowerCase() + "|" + fwhtrk.offerDesc;
            } else {
                if (orderViewModel.offerCardType) {
                    fwhtrk.user.promo = orderViewModel.offerCardType.toLowerCase() + "|" + fwhtrk.offerDesc;
                } else {
                    fwhtrk.user.promo = "n/a";
                }
            }
            if (orderViewModel.currentOrder.cartQuantity > 0) {
                this.attemptTrack('PDP_Cart_PageView')
            }
        };
        this.removeMultipleItemsProductString = function (items) {
            var prodCartString = buildCartString(items);
            fwhtrk.products = prodCartString.toLowerCase().replace(/evar/g, "eVar");
            fwhtrk.page.products = prodCartString.toLowerCase().replace(/evar/g, "eVar");
        }
        this.cartString = function (model, getCopyText, ProductOriginSource) {

            var prodCartString = buildCartString(model.Items);
            fwhtrk.products = prodCartString.toLowerCase().replace(/evar/g, "eVar");
            fwhtrk.page.products = prodCartString.toLowerCase().replace(/evar/g, "eVar");
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + getCopyText;
            fwhtrk.event.itemaddedtobag = 1;
            fwhtrk.page.orderSourceType = ProductOriginSource;
            fwhtrk.orderSourceType = ProductOriginSource;
            if (getCopyText == "increase quantity") {
                fwhtrk.event.ComboPriceAdded = 1;
                this.attemptTrack("addToBag");
            } else {
                this.attemptTrack("remove from cart");
            }
        };
        this.deliveryErrorClick = function (buttonclicktext) {
            fwhtrk.page.link = deliveryError.screenName + "|" + buttonclicktext;
        };
        this.deliveryErrorPopUp = function (errorMessageText, childErrorcode) {
            fwhtrk.page.event.errorMessage = 1;
            fwhtrk.errorMessage = errorMessageText;
            fwhtrk.event.errormessage = 1;
            fwhtrk.page.errorMessage = errorMessageText;
            fwhtrk.parentErrorCode = "n/a";
            fwhtrk.childErrorCode = childErrorcode;
            fwhtrk.event.errorMessageMW = 1;
            this.attemptTrack("modal_pageview");
        };
        this.updateMaintainCart = function (errorMessageText) {
            fwhtrk.page.virtualname = getDomainName() + $("#dtmPageName").val().toLowerCase() + ":" + "out of stock modal";
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            fwhtrk.page.warningMessage = errorMessageText;
            fwhtrk.page.event.warningMessage = 1;
            this.attemptTrack("modal_pageview");
        };
        this.removeMaintainCart = function (productsData = [], maintainCartBtn, btnTxt) {
            const productStringArray = productsData.map((products) => {
                const { categoryName, productName, price, quantity, categoryId,
                    productId, options, combo } = products;
                return getCartProductsRemove(categoryName, productName, "", price, quantity, categoryId,
                    productId, false, undefined, undefined, options, combo);
            }).join(",").toLowerCase();
            fwhtrk.page.removedProduct = productStringArray;
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val().toLowerCase() + "|" + "out of stock modal - " + btnTxt;
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            fwhtrk.page.virtualname = getDomainName() + $("#dtmPageName").val().toLowerCase() + ":" + "out of stock modal";
            fwhtrk.page.event.itemRemoved = productsData.length > 0 ? 1 : 0;
            if (maintainCartBtn) {
                fwhtrk.event.startonlineorder = 1;
            }
            this.attemptTrack("remove from cart");
        };
        this.lastOrderReOrderPopup = function (errorMessageText) {
            fwhtrk.page.virtualname = getDomainName() + $("#dtmPageName").val().toLowerCase() + ":" + "out of stock modal";
            fwhtrk.page.warningMessage = errorMessageText;
            fwhtrk.page.event.warningMessage = 1;
            this.attemptTrack('modal_pageview');
        };
        this.lastOrderReOrderPopupModalPageView = function () {
            fwhtrk.reorder = 1;
            fwhtrk.event.startonlineorder = 1;
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() + "|" + "re-order";
            this.attemptTrack("dashboard_click_action");
        };

        this.closeModal = function () {
            fwhtrk.page.virtualname = "";
            fwhtrk.reorder = 0;
            fwhtrk.event.startonlineorder = 0;
            fwhtrk.event.viewRewards = 0;
            fwhtrk.page.link = '';
        };

        this.deliveryLocator = function () {
            fwhtrk.event.startonlineorder = 1;
            if (orderViewModel.Analytics.isRecentLocation === true) {
                fwhtrk.addressSource = addressSource.recentLocation;
            } else {
                fwhtrk.addressSource = addressSource.manualLocation;
            }
        };
        this.startOrder = function (number, buttonText) {
            fwhtrk.event.startonlineorder = number;
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.toLowerCase();
            this.attemptTrack("dashboard_click_action");
        };
        this.AddRemoveProductTracking = function (products, getCopyText, ProductOriginSource) {
            var $productCartitems = products;
            var objproductClass = [];

            $productCartitems.each(function () {
                var IsMeal = false;
                var productName = this.getAttribute("data-product-name");
                var analyticsObj = this.getAttribute("data-analytics") || '{}'
                var categoryName = JSON.parse(analyticsObj).categoryName || this.getAttribute("data-categoryname") || ''
                var price = this.getAttribute("data-price");
                var quantity = this.getAttribute("data-qty");
                var options = this.getAttribute("data-options") || '[]';
                var productId = this.getAttribute("data-product-id");
                var categoryId = this.getAttribute("data-product-class-groupid");
                var meal = this.getAttribute("data-combo");
                if (meal !== "null") {
                    IsMeal = true;
                    fwhtrk.event.MIAMPriceAdded = 1;
                }

                var extrasPrice = getExtrasPrice(JSON.parse(options));
                if (extrasPrice) {
                    fwhtrk.event.ExtrasPriceAdded = 1;
                }
                fwhtrk.event.productPriceAdded = 1;
                fwhtrk.event.productQuantityAdded = 1;

                var items = { Analytics: JSON.parse(analyticsObj), Options: JSON.parse(options), ProductId: productId, ProductClassGroupId: categoryId, CategoryName: categoryName, Name: productName, Price: price, Quantity: quantity, Meal: meal, IsMeal: IsMeal };
                objproductClass.push(items);
            });
            ProductModal.Items = objproductClass;
            analytics.cartString(ProductModal, getCopyText, ProductOriginSource);
        };
        this.AddProduct = function (categoryName, productName, productNameWithoutSize, price, categoryId, productId, getAddText, ingredintsArray, combo, anlyticsComboSrc, source) {
            var productString = getCartProductsADD(categoryName, productName, productNameWithoutSize, price, 1, categoryId, productId, true, undefined, undefined, ingredintsArray, combo, source);
            fwhtrk.products = productString.toLowerCase();
            fwhtrk.page.products = productString.toLowerCase();
            fwhtrk.page.addedProduct = productString.toLowerCase().replace(/evar/g, "eVar");
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + getAddText;
            const breadOption = ingredintsArray && getBreadOption(getCartIngredient(ingredintsArray, ""));
            if (breadOption && breadOption.indexOf('Toasted') >= 0) {
                fwhtrk.page.event.toasted = 1;
            }
            fwhtrk.event.itemAdded = 1;
        };
        this.RemoveProduct = function (categoryName, productName, productNameWithoutSize, price, categoryId, productId, getRemoveText, quantity, totalprice, ingredientsList, combo, anlyticsComboSrc, source) {
            if (getRemoveText == "decrease quantity") {
                var productString = getCartProductsRemove(categoryName, productName, productNameWithoutSize, price, 1, categoryId, productId, false, undefined, undefined, ingredientsList, combo, source);
            }
            if (getRemoveText == "remove") {
                var productString = getCartProductsRemove(categoryName, productName, productNameWithoutSize, totalprice, quantity, categoryId, productId, false, undefined, undefined, ingredientsList, combo, source);
            }
            fwhtrk.products = productString.toLowerCase();
            fwhtrk.page.products = productString.toLowerCase();
            fwhtrk.page.removedProduct = productString.toLowerCase().replace(/evar/g, "eVar");
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + getRemoveText;
            fwhtrk.event.productPriceRemove = 1;
            fwhtrk.event.productQuantityRemove = 1;
            fwhtrk.event.MIAMPriceRemove = 1;
            fwhtrk.event.ExtrasPriceRemove = 1;
            fwhtrk.event.itemRemoved = 1;
            fwhtrk.event.ComboPriceRemove = 1;
        };
        this.removeUnavailableProduct = function (categoryName, productName, price, quantity, categoryId, productId, TotalPrice, options, combo, source) {
            var productString = getCartProductsRemove(categoryName, productName, productName, price, quantity, categoryId, productId, false, undefined, undefined, options, combo, source);
            return productString;
        };
        this.removedProductsString = function (removedproducts) {
            let finalstring = removedproducts.join(';');
            fwhtrk.page.removedProduct = finalstring.toLowerCase().replace(/evar/g, "eVar");
        };
        this.removalBannerAnalytics = function (message) {
            fwhtrk.bannerMessage = message.toLowerCase();
            fwhtrk.event.bannerImpression = 1;
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + "header:banner impression";
            if (isUserLoggedIn) {
                fwhtrk.loginStatus = "logged-in";
            } else {
                fwhtrk.loginStatus = "logged-out";
            }
            var item = orderViewModel.itemPromotionAnalytics;
            if (item && item.cardType) {
                fwhtrk.event.dealApplied = 1;
                if (item.cardType.toLowerCase() == "s&d" || item.cardType.toLowerCase() == "non s&d") {
                    fwhtrk.offerDesc = item.titleDisplayText ? item.titleDisplayText.toLowerCase() : "n/a";
                    fwhtrk.user.promo = item.cardType.toLowerCase() + "|" + fwhtrk.offerDesc;
                    fwhtrk.user.dealplu = item.id;
                } else {
                    fwhtrk.offerDesc = item.titleDisplayText ? item.titleDisplayText.toLowerCase() : "n/a";
                    fwhtrk.user.promo = item.promoCode ? item.promoCode.toLowerCase() + "|" + fwhtrk.offerDesc : "n/a";
                    fwhtrk.user.dealplu = item.promoPLU;
                }
            }
        };
        this.manualBannerDismissAnalytics = function () {
            fwhtrk.event.bannerImpression = 0;
            fwhtrk.event.bannerDismiss = 1;
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + "header:banner dismiss";
            this.attemptTrack("banner_notification_dismiss");
        };
        this.favoriteId = function (favoriteId) {
            fwhtrk.itemFavoritedID = favoriteId;
        };
        this.clickFunction = function (buttonText) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + buttonText;
            this.attemptTrack("view_order_details");
        };
        this.OrderSourceType = function (orderSourceType) {
            fwhtrk.orderSourceType = orderSourceType.toLowerCase();
        };

        this.orderConfirmationPageTracking = function (orderConfirmationDetails) {
            var orderType = getOrderTypeByFulfillmentType(
                orderConfirmationDetails.FulfillmentType
            );
            var curbsideDelivery = 0;
            if (orderConfirmationDetails.IsCurbSidePickup) {
                curbsideDelivery = 1;
            }
            var products = orderConfirmationDetails.Items;
            var certsApplied = orderConfirmationDetails.Certs;
            var certificateDiscount = 0;
            var paymentMethods = [];
            if (orderConfirmationDetails.PaymentMethods.length > 0) {
                orderConfirmationDetails.PaymentMethods.forEach((pay) => {
                    if (pay.Issuer === "subway") {
                        paymentMethods.push("giftcard;" + pay.Issuer);
                    } else {
                        paymentMethods.push(pay.Issuer);
                    }
                });
            }
            var currency = orderConfirmationDetails.ISOCurrencyCode
                ? orderConfirmationDetails.ISOCurrencyCode
                : "";
            var purchaseID = orderConfirmationDetails.OrderNumber;
            var discount = orderConfirmationDetails.Deals
                ? orderConfirmationDetails.Deals
                : 0;
            var taxes = orderConfirmationDetails.Tax; //[0].amount;
            var taxesTotal = orderConfirmationDetails.TaxAndFees;
            var orderValue = orderConfirmationDetails.Subtotal;
            var OrderTotal = orderConfirmationDetails.OrderTotal;
            var orderId = orderConfirmationDetails.orederId;
            var orderTotalPrice = orderConfirmationDetails.OrderTotal;
            var offerId = orderConfirmationDetails.OfferId;
            var offerDescription = orderConfirmationDetails.OfferDescription;
            var certDiscount = orderConfirmationDetails.certificateAmount;
            var promotionDiscount = orderConfirmationDetails.PromotionAmount;
            var Satip = orderConfirmationDetails.Totals.Tips;
            var WithoutSatipComponent = orderConfirmationDetails.supportsSATip;

            //if (certDiscount > 0) {
            //    fwhtrk.offerDesc = certificatediscount;
            //}
            //else if (promotionDiscount > 0) {
            //    fwhtrk.offerDesc = promodiscount;
            //}
            //else if (certDiscount > 0 && promotionDiscount > 0) {
            //    fwhtrk.offerDesc = certificatediscount +";"+ promodiscount;
            //}

            //for (i = 0; i < taxes.length; i++) {
            //    taxesTotal = taxesTotal + taxes[i].amount;
            //}
            var isCertificateApplied = certsApplied
                ? certsApplied.length > 0
                    ? "yes"
                    : "no"
                : "no";
            if (certsApplied != null && certsApplied.length > 0) {
                certificateDiscount = certsApplied.reduce(function (sum, cert) {
                    return sum + cert.RedeemedAmount;
                }, 0);
            }
            // if (!!taxes) {
            //taxesTotal = taxes.reduce(function (sum, tax) {
            //    return sum + (tax.Amount);
            //}, 0);
            //}
            //for (i = 0; i < offers.length; i++) {
            //    if (i.length > 1) {
            //        offers.OfferId
            //    }
            //}
            if (offerId != null && offerDescription != null) {
                fwhtrk.offerDesc = offerDescription;
                fwhtrk.offerID = offerId;
            } else {
                fwhtrk.offerDesc = "";
                fwhtrk.offerID = "";
            }
            if (
                orderConfirmationDetails.Delivery &&
                orderConfirmationDetails.Delivery.IsContactlessDelivery
            ) {
                fwhtrk.contactlessDelivery = 1;
            } else {
                fwhtrk.contactlessDelivery = 0;
            }
            if (
                orderConfirmationDetails.Totals.DeliveryCharges &&
                orderConfirmationDetails.Totals.DeliveryCharges.Fees
            ) {
                fwhtrk.otherFees =
                    orderConfirmationDetails.Totals.DeliveryCharges.Fees.OtherFeesTotal;
            }
            fwhtrk.transactionID = purchaseID;
            fwhtrk.ConsumerPrice = OrderTotal;
            fwhtrk.tax = taxes;
            fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            fwhtrk.page.event.purchase = 1;
            fwhtrk.page.event.certificateDiscount = certificateDiscount;
            fwhtrk.page.event.discount = discount;
            fwhtrk.itemUnits = orderConfirmationDetails.QuantityCount;
            fwhtrk.itemPrice = orderConfirmationDetails.LineItemSubTotal;
            fwhtrk.user.billingZip = orderConfirmationDetails.ZipCode;
            fwhtrk.discount = discount;
            fwhtrk.page.event.tax = taxes;
            fwhtrk.event.certsApplied = certsApplied ? certsApplied.length : 0;
            fwhtrk.page.event.curbsideDelivery = curbsideDelivery;
            fwhtrk.paymentMethod = paymentMethods.join("|");
            fwhtrk.orderValue = orderValue;
            fwhtrk.currency = currency;
            fwhtrk.purchaseID = purchaseID + "|" + orderConfirmationDetails.StoreId;
            fwhtrk.orderType = orderType;
            fwhtrk.certificateApplied = isCertificateApplied;
            fwhtrk.cartID = orderConfirmationDetails.CartId;
            if (orderConfirmationDetails.OfferList.length != 0) {
                let promoData = orderConfirmationDetails.OfferList.filter((val) => val.promoCode != "")
                if ((promoData).length != 0) {
                    fwhtrk.event.promoApplied = 1;
                }
                let offerExist = orderConfirmationDetails.OfferList.filter((val) => val.promoCode == "")
                if (offerExist.length != 0) {
                    fwhtrk.event.dealRedeemed = 1;
                    fwhtrk.rewardName = offerExist.map((val) => val.offerDescription)
                }
            }
            if (orderConfirmationDetails.Rewards) {
                fwhtrk.event.rewardApplied = 1;
                fwhtrk.event.certDiscAmt = orderConfirmationDetails.Rewards;
                fwhtrk.event.rewardPoints = orderConfirmationDetails.TotalRedeemedPoints;
                fwhtrk.event.rewardPrice = orderConfirmationDetails.Rewards;
            }
            if (orderViewModel.orderStatusClicked) {
                fwhtrk.page.name = fwhtrk.page.name.replace("order confirmation", "order details");
                fwhtrk.page.section = fwhtrk.page.section.replace("order confirm", "order details");
            }
            fwhtrk.event.MIAMPricePurchase = 1;
            fwhtrk.event.ExtrasPricePurchase = 1;
            fwhtrk.event.purchase = 1;
            fwhtrk.event.ComboPricePurchase = 1;
            var productString = buildProductsString(
                products,
                certificateDiscount,
                discount,
                taxesTotal,
                orderTotalPrice,
                true
            );
            fwhtrk.page.products = productString
                .toLowerCase()
                .replace(/evar/g, "eVar");
            fwhtrk.products = productString.toLowerCase().replace(/evar/g, "eVar");
            fwhtrk.event.sandwichArtistTipAmount = Satip;
            const percentage = Math.round((Satip / orderValue) * 100);
            const default_tips = [10, 15];
            if (WithoutSatipComponent) {
                if (Satip == 0) {
                    fwhtrk.sandwichArtistTipPercent = "no tip";
                }
                else {
                    default_tips.includes(percentage) ? fwhtrk.sandwichArtistTipPercent = "default:" + percentage : fwhtrk.sandwichArtistTipPercent = "other:" + Satip;
                }
            }
            else
                fwhtrk.sandwichArtistTipPercent = "n/a";

            this.attemptTrack("orderConfirmationPage");
        };

        this.curbSideModalConfirmationPage = function (CTAText, contactRestaurent, getDirection) {
            fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + CTAText;
            fwhtrk.page.virtualname = '';
            fwhtrk.event.clicktocall = 0;
            fwhtrk.page.event.storeGetDirections = 0;
            if (orderViewModel.orderStatusClicked) {
                fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
                fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
                fwhtrk.page.name = fwhtrk.page.name.replace("order confirmation", "order details");
                fwhtrk.page.section = fwhtrk.page.section.replace("order confirm", "order details");
                fwhtrk.page.link = fwhtrk.page.section + "|" + CTAText;
            }
            if (contactRestaurent) {
                fwhtrk.event.clicktocall = 1;
            }
            if (getDirection) {
                fwhtrk.page.event.storeGetDirections = 1;
            }
            if (orderViewModel.orderStatusClicked) {
                this.attemptTrack("order_details_click_cta");
            } else {
                this.attemptTrack("order_confirmation_click_cta");
            }
        }

        this.curbSideModalCTA = function (CTAText) {
            fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + CTAText;
            fwhtrk.event.clicktocall = 0;
            fwhtrk.page.event.storeGetDirections = 0;
            if (orderViewModel.orderStatusClicked) {
                fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
                fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
                fwhtrk.page.name = fwhtrk.page.name.replace("order confirmation", "order details");
                fwhtrk.page.section = fwhtrk.page.section.replace("order confirm", "order details");
                fwhtrk.page.link = fwhtrk.page.section + "|" + CTAText;
            }
            fwhtrk.page.virtualname = fwhtrk.page.name + ":curbside arrival modal";
            if (orderViewModel.orderStatusClicked) {
                this.attemptTrack("order_details_click_cta");
            } else {
                this.attemptTrack("order_confirmation_click_cta");
            }
        }

        this.curbsideModalClose = function () {
            fwhtrk.page.virtualname = fwhtrk.page.name + ":curbside arrival modal";
            setTimeout(() => {
                fwhtrk.page.virtualname = '';
            }, 500);

        }

        this.curbsideContinueCTA = function () {
            fwhtrk.page.name = getDomainName() +
                ":" +
                orderViewModel.headerFooterLanguageCode +
                ":" +
                "curbside vehicle selection modal";
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val().toLowerCase() + "|vehicle selection modal:continue to payment"
            this.attemptTrack("continue to payment");
        }

        this.iAmHereCTA = function () {
            fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + "i'm here";
            fwhtrk.page.virtualname = '';
            fwhtrk.event.clicktocall = 0;
            fwhtrk.page.event.storeGetDirections = 0;
            if (orderViewModel.orderStatusClicked) {
                fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
                fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
                fwhtrk.page.name = fwhtrk.page.name.replace("order confirmation", "order details");
                fwhtrk.page.section = fwhtrk.page.section.replace("order confirm", "order details");
                fwhtrk.page.link = fwhtrk.page.section + "|" + "i'm here";
            }
            if (orderViewModel.orderStatusClicked) {
                this.attemptTrack("order_details_click_cta");
            } else {
                this.attemptTrack("order_confirmation_click_cta");
            }
        }

        this.curbsideModalShow = function () {
            fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
            fwhtrk.page.section = $("#dtmPageSection").val().toLowerCase();
            if (orderViewModel.orderStatusClicked) {
                fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
                fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
                fwhtrk.page.name = fwhtrk.page.name.replace("order confirmation", "order details");
                fwhtrk.page.section = fwhtrk.page.section.replace("order confirm", "order details");
            }
            fwhtrk.page.virtualname = fwhtrk.page.name + ":curbside arrival modal";
            this.attemptTrack('modal_pageview');
        }

        this.Unavailabilty = function (UnavailableContent) {
            if (UnavailableContent !== "" && UnavailableContent !== null) {
                fwhtrk.page.event.warningMessage = 1;
                fwhtrk.page.warningMessage = UnavailableContent;
                this.attemptTrack("warning message");
            }
        };
        this.goprobannerclick = function (label) {
            fwhtrk.page.link = label;
            this.attemptTrack("Customizer Promotional Banner");
        };
        this.upsellselected = function (upsellName) {
            fwhtrk.page.link = upsellName;
            fwhtrk.page.event.nutritionalUnitChanged = 1;
            this.attemptTrack("addextras");
        };
        this.ingredientSelected = function (optionName) {
            fwhtrk.page.link = optionName;
            this.attemptTrack("picker");
        };
        this.signupSourceTracking = function (signupSource) {
            if (signupSource === this.loyaltyAcquisitionModal.joinNow) {
                fwhtrk.page.user.newAccountSource = newAccountSource.acquistionModal;
            } else if (
                signupSource === this.loyaltyAcquisitionModal.myWayRewardsModal
            ) {
                fwhtrk.page.user.newAccountSource = newAccountSource.rewardJoinButton;
            } else if (signupSource === this.loyaltyAcquisitionModal.orderConf) {
                fwhtrk.page.user.newAccountSource = newAccountSource.topNav;
            }
            this.attemptTrack(this.loyaltyAcquisitionModal.orderConf);
        };

        this.homePage = function (data) {
            var promoValue = "";
            if (data !== null) {
                $.each(data.dealAndPromoCards, function () {
                    promoValue =
                        promoValue + this.cardType + "|" + this.titleDisplayText + ";";
                });
            }
            fwhtrk.page.section = "order";
            fwhtrk.event.promoView = 1;
            fwhtrk.user.promo = promoValue;
        };

        this.primaryCTAClickTracking = function (cta, cardType, promoValue) {
            fwhtrk.event.promoPrimaryCTAClick = 1;
            fwhtrk.linkName = cta;
            if (cardType.toLowerCase() === "s&d") {
                cardType = "";
            } else {
                cardType = cardType + "|";
            }
            fwhtrk.user.promo = cardType + promoValue;
            this.attemptTrack("promo cta");
        };

        this.secondaryCTAClickTracking = function (cta, cardType, promoValue) {
            fwhtrk.event.promoSecndaryCTAClick = 1;
            fwhtrk.linkName = cta;
            fwhtrk.user.promo = cardType + "|" + promoValue;
            this.attemptTrack("promo details cta");
        };

        this.invalidOffers = function (cta, cardType, promoValue) {
            fwhtrk.linkName = cta;
            fwhtrk.user.promo = cardType + "|" + promoValue;
            this.attemptTrack("promo not valid");
        };

        this.offerSuccessfull = function (cardType, promoValue) {
            fwhtrk.event.promoApplied = 1;
            fwhtrk.user.promo = cardType + "|" + promoValue;
            this.attemptTrack("promo applied");
        };

        this.vanityCodeApplied = function (
            vanityCode,
            promoApplied,
            promoError,
            errorMessage,
            CTAText
        ) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + CTAText;
            fwhtrk.event.promoApplied = promoApplied;
            fwhtrk.event.promoError = promoError;
            fwhtrk.user.promo = vanityCode;
            if (errorMessage) {
                fwhtrk.errorMessage = errorMessage;
                fwhtrk.event.errormessage = 1;
            }
            this.attemptTrack("cart promo code apply");
        };

        this.clearErrorEvent = function (myEvent) {
            if (myEvent && myEvent.errormessage) {
                delete myEvent.errormessage;
            }
        };

        this.vanityCodePlaceOrder = function (vanityCode, placeOrder, CTAText) {
            fwhtrk.user.promo = vanityCode;
            fwhtrk.event.placeOrder = placeOrder;
            fwhtrk.page.link =
                fwhtrk.page.section + "|vehicle selection modal:" + CTAText;
        };
        this.curbsidePickUpLoad = function (
            isCurbsideAvailable,
            isCurbsideSelected
        ) {
            //fwhtrk.page.section = "order:bag";
            fwhtrk.page.curbsideAvailable = isCurbsideAvailable;
            fwhtrk.page.event.curbsideSelected = isCurbsideSelected;
        };

        this.curbsideToggleOn = function (isCurbsideSelected) {
            fwhtrk.page.event.curbsideSelected = isCurbsideSelected;
        };

        this.curbsidePickupCTAClick = function (ctaText, buttontext) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + buttontext.toLowerCase();
            if (ctaText != "login and continue") {
                fwhtrk.event.checkoutstarted = 1;
                fwhtrk.event.productPriceCheckout = 1
                fwhtrk.event.productQuantityCheckout = 1
                fwhtrk.event.MIAMPriceCheckout = 1
                fwhtrk.event.ExtrasPriceCheckout = 1
                var prdString = addEvents_productString()
                fwhtrk.products = prdString;
                fwhtrk.page.products = prdString
                fwhtrk.event.ComboPriceCheckout = 1

            }
            this.attemptTrack(ctaText);
        };

        this.continueButtonCTAClick = function (orderTypeName) {
            if (orderTypeName) {
                fwhtrk.orderType = orderTypeName;
            } else if (orderViewModel.Analytics.orderType) {
                fwhtrk.orderType = orderViewModel.Analytics.orderType;
            } else {
                fwhtrk.orderType = "n/a";
            }
            fwhtrk.event.cartContinue = 1;
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + "continue";
        };

        this.curbsideVechicleModalLoad = function () {
            fwhtrk.page.event.vechicleSelected = 1;
            fwhtrk.page.virtualname = getDomainName() + $("#dtmPageName").val() + ":curbside vehicle selection modal";
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + "vehicle selection modal" + ":" + "continue";
            this.attemptTrack("modal_pageview");
        };

        this.curbsideVechicleModalClose = function () {
            fwhtrk.page.virtualname = "";
        };

        this.orderConfirmationCommon = function (pageName, pageSection) {
            fwhtrk.page.name = pageName.toLowerCase();
            fwhtrk.page.section = pageSection;
        };

        this.orderConfirmationCTA = function (ctaText) {
            this.orderConfirmationCommon(getDomainName() + ":bag:confirmation", getDomainName() + ":bag");
        };
        this.offers = function (offerId, offerDescription) {
            fwhtrk.offerID = offerId;
            fwhtrk.offerDesc = offerDescription;
        };
        this.curgsideOrderStatus = function (orderStatus, ctaText, errormessage) {
            this.orderConfirmationCommon(getDomainName() + ":bag:confirmation", getDomainName() + ":bag");
            fwhtrk.page.orderstatus = orderStatus;
        };
        this.pageError = function (
            errorTitle,
            errorMessage,
            parentCode = "n/a",
            childErrorCode = "n/a",
            isMWError
        ) {
            if (!errorTitle) {
                errorTitle = $("#error-title").data("fallbackErrorTitle");
            }
            if (!errorMessage) {
                errorMessage = $("#error-body").data("fallbackErrorBody");
            }
            fwhtrk.page.errorMessage = errorMessage;
            fwhtrk.page.event.errorMessage = 1;
            fwhtrk.errorMessage = errorMessage;
            fwhtrk.event.errormessage = 1;
            fwhtrk.parentErrorCode =
                parentCode.indexOf("DORD") >= 0 ? parentCode : "n/a";
            fwhtrk.childErrorCode =
                childErrorCode.indexOf("DORD") < 0 ? childErrorCode : "n/a";
            if (isMWError) fwhtrk.event.errorMessageMW = 1;
            else fwhtrk.event.errorMessageUI = 1;
            fwhtrk.page.virtualname =
                getDomainName() + $("#dtmPageName").val().toLowerCase() + ":" + "error warning modal";
            this.attemptTrack("errorMessage");
        };
        this.pageProducts = function (
            productNames,
            categories,
            quantities,
            prices
        ) {
            fwhtrk.page.product.name = this.getProductArray(productNames);
            fwhtrk.page.product.category = this.getProductArray(categories);
            fwhtrk.page.product.quantity = this.getProductArray(quantities);
            fwhtrk.page.product.price = this.getProductArray(prices);
            this.attemptTrack("pageProducts");
        };
        this.getProductArray = function (inputArray) {
            var results = [];
            if (inputArray.length > 0) {
                for (var i = 0; i < inputArray.length; i = i + 1) {
                    results.push(inputArray[i]);
                }
            }
            return results;
        };
        this.nutritionalUnitChanged = function (isChanged) {
            fwhtrk.page.event.nutritionalUnitChanged = isChanged;
        };
        this.createCart = function (cartid) {
            fwhtrk.cartID = cartid;
        };

        this.ReOrderCart = function (cartid) {
            fwhtrk.cartID = cartid;
        };
        this.favoriteCart = function (cartid, favoriteId) {
            fwhtrk.cartID = cartid;
            fwhtrk.itemFavoritedID = favoriteId;
        };
        this.addPageProductAnalytics = function (productCartItems) {
            var $productCartitems = productCartItems;
            var productNames = [];
            var prices = [];
            var quantities = [];
            var catergories = [];
            $productCartitems.each(function () {
                var $currentProductItem = $(this);
                var productName = $currentProductItem.find(
                    ".accordion-confirmation-item-name"
                )[0].textContent;
                if (productName === undefined) {
                    productName = $currentProductItem.find(
                        ".accordion-confirmation-item-name"
                    )[0].textContent;
                }
                var price = $currentProductItem.data("price");
                var category = $currentProductItem.data("productClassGroupid");
                var quantity = $currentProductItem.data("qty");
                productNames.push(productName);
                prices.push(price);
                if (category !== undefined && category !== null) {
                    catergories.push(category);
                }
                quantities.push(quantity);
            });
            analytics.pageProducts(productNames, catergories, quantities, prices);
        };
        this.addPageProductsAnalytics = function (productCartItems) {
            var $productCartitems = productCartItems;
            var productNames = [];
            var prices = [];
            var quantities = [];
            var catergories = [];
            $productCartitems.each(function () {
                var $currentProductItem = $(this);
                //var productId = $currentProductItem.data('productId');
                var productName = $currentProductItem.find(".accordion-item-name")[0]
                    .textContent;
                if (productName === undefined) {
                    productName = $currentProductItem.find(".accordion-item-name")[0]
                        .textContent;
                }
                var price = $currentProductItem.data("price");
                var category = $currentProductItem.data("categoryname");
                var quantity = $currentProductItem.data("qty");
                productNames.push(productName);
                prices.push(price);
                if (category !== undefined && category !== null) {
                    catergories.push(category);
                }
                quantities.push(quantity);
            });
            analytics.pageProducts(productNames, catergories, quantities, prices);
        };

        this.lastorderReorder = function (buttonText, OrderSourceType) {
            fwhtrk.reorder = 1;
            fwhtrk.orderSourceType = OrderSourceType.toLowerCase();
            fwhtrk.event.startonlineorder = 1;
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.toLowerCase();
            this.attemptTrack("dashboard_click_action");
        };
        this.getOrderStatus = function (orderStatus) {
            fwhtrk.page.orderstatus = orderStatus.toLowerCase();
        };
        this.addProductCategory = function (categoryName) {
            fwhtrk.page.product.category = [categoryName];
            fwhtrk.page.event.itemViewed = 1;
            var subCat = orderViewModel.subCategory;
            if (subCat) {
                fwhtrk.page.product.subCategory = subCat.toLowerCase();
            }
        };
        this.badgeTileClick = function (badgeText) {
            fwhtrk.product.productBadge = badgeText.toLowerCase();
        };
        //this.addPDPSectionPageNames = function () {
        //    fwhtrk.page.name = "order:" + document.getElementById('scLanguageCode').value.toLowerCase() + ":product page";
        //    fwhtrk.page.section = "order:product details";
        //}
        this.productCustomized = function (cust) {
            fwhtrk.page.event.sandwichCustomized = cust;
            fwhtrk.event.sandwichCustomized = cust;
        };
        this.addPDPProducts = function (categoryName, prdName) {
            window.fwhtrk.page.products =
                categoryName.toLowerCase() +
                ";" +
                prdName.replace(",", "/").toLowerCase();
        };

        this.dealsDetailsComp = function (title, desc, dealType, id, pageName, linkText) {
            fwhtrk.event.promoDetails = 1;
            fwhtrk.offerDesc = desc ? desc.toLowerCase() : "n/a";
            fwhtrk.user.promo =
                dealType.toLowerCase() + "|" + (title ? title.toLowerCase() : "n/a");
            fwhtrk.user.dealplu = id ? id.toLowerCase() : "n/a";
            fwhtrk.page.name = getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":" + pageName;
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + linkText.toLowerCase();
            this.attemptTrack("deals_page_click_action");
        };

        this.dealsListComponent = function (promoList) {
            fwhtrk.event.promoDetails = 0;
            fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
            fwhtrk.user.promoList = promoList && promoList.toString();
            if (window.location.href.indexOf("rewards-activity") < 0) {
                analytics.attemptTrack("dealView_pageView");
            }
        };

        this.dealsDetail = function(pageName) {
            fwhtrk.page.link = "";
            fwhtrk.event.promoDetails = 1;
            fwhtrk.page.name = `${getDomainName()}:${$("#scLanguageCode").val().toLowerCase()}:${pageName}`;
            this.attemptTrack("dealView_pageView"); 
        }

        this.dealsAndPromotionsClicked = function (
            data,
            totalCount,
            pos,
            btnCTA,
            isDealDetailsPage
        ) {
            fwhtrk.event.startonlineorder = 0;
            fwhtrk.reorder = 0;
            if (btnCTA.toLowerCase() != "learn more") {
                orderViewModel.offerCardType = data.cardType ? data.cardType.toLowerCase() : "";
                orderViewModel.save();
                fwhtrk.user.promo =
                    data.cardType.toLowerCase() +
                    "|" +
                    (data.titleDisplayText ? data.titleDisplayText.toLowerCase() : "n/a");
                fwhtrk.user.dealplu = data.id ? data.id.toLowerCase() : "n/a";
                if (!isCurrentPage("home")) {
                    position = pos + 1;
                    fwhtrk.position = totalCount + "|" + position;
                }
                fwhtrk.offerDesc = data.descriptionDisplayText
                    ? data.descriptionDisplayText.toLowerCase()
                    : "n/a";
            }
            fwhtrk.intCmp = data.cardDetailsCTA.web && data.cardDetailsCTA.web[0].intCmp ? data.cardDetailsCTA.web[0].intCmp : 'n/a'


            if (btnCTA.toLowerCase() == "learn more") {
                fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + btnCTA.toLowerCase();
                fwhtrk.event.promoDetails = 1;
            } else {
                fwhtrk.page.link =
                    getDomainName() + $("#dtmPageSection").val() + "|" + btnCTA.toLowerCase();

                fwhtrk.event.promoDetails = 0;
            }
            if (btnCTA.toLowerCase() == 'shop deal') {
                fwhtrk.event.startonlineorder = 1;
            }
            if (btnCTA.toLowerCase() == "learn more") {
                this.attemptTrack("dashboard_click_action")
            }
            else if (isCurrentPage("home")) {
                if (isDealDetailsPage) {
                    fwhtrk.event.promoPrimaryCTAClick = 0;
                    fwhtrk.event.promoSecondaryCTAClick = 1;
                    this.attemptTrack("deals_secondary_click_action")
                } else {
                    fwhtrk.event.promoPrimaryCTAClick = 1;
                    fwhtrk.event.promoSecondaryCTAClick = 0;
                    this.attemptTrack("deals_primary_click_action")
                }
            } else {
                if (isDealDetailsPage) {
                    fwhtrk.event.promoPrimaryCTAClick = 0;
                    fwhtrk.event.promoSecondaryCTAClick = 1;
                    this.attemptTrack("deals_secondary_click_action")
                } else {
                    fwhtrk.event.promoPrimaryCTAClick = 1;
                    fwhtrk.event.promoSecondaryCTAClick = 0;
                    this.attemptTrack("deals_primary_click_action")
                }
            }

        };
        this.dealBackClick = function () {
            fwhtrk.event.promoDetails = 0;
            analytics.attemptTrack("dealView_pageView");
        }
        this.joinNowModal = function () {
            fwhtrk.page.virtualname =
                fwhtrk.page.name + ":" + "loyalty acquisition modal";
        };

        this.joinNowCTA = function () {
            fwhtrk.page.virtualname =
                fwhtrk.page.name + ":" + "loyalty acquisition modal";
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + "join now";
        };

        this.dealPromoCTA = function (ctaText) {
            if (ctaText.toLowerCase() == "cancel and keep delivery") {
                fwhtrk.page.event.warningMessage = 0;
            }
            fwhtrk.page.virtualname = fwhtrk.page.name + ":" + "deal not available error modal"
            fwhtrk.page.link = fwhtrk.page.section + "|" + ctaText.toLowerCase();
            this.attemptTrack("modal_cta_click_action");
        }

        this.dealErroModal = function (title) {
            fwhtrk.page.virtualname = fwhtrk.page.name + ":" + "deal not available error modal"
            fwhtrk.page.warningMessage = title.toLowerCase();
            fwhtrk.page.event.warningMessage = 1;
            this.attemptTrack("modal_pageview");
        }

        this.openDealsandPromoModal = function () {
            fwhtrk.page.virtualname =
                getDomainName() + ":" +
                orderViewModel.headerFooterLanguageCode.toLowerCase() +
                ":home:deals and promo modal";
            this.attemptTrack("modal_pageview");
        };

        this.profileSignOutClick = function () {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|sign out";
            this.attemptTrack("dashboard_click_action");
        };

        this.profileLinksClickAnalytics = function (linkname) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + linkname.toLowerCase();
            this.attemptTrack("profile_click_action");
        };
        this.phoneUniqueness = function (message = '') {
            fwhtrk.page.warningMessage = message.toLowerCase();
            fwhtrk.page.event.warningMessage = 1;
            fwhtrk.parentErrorCode = "n/a";
            fwhtrk.childErrorCode = "n/a";
        };
        this.resetPhoneUniqueness = function () {
            fwhtrk.errorMessage = "";
            fwhtrk.event.errorMessage = 0;
            fwhtrk.event.errorMessageMW = 0;
            fwhtrk.event.errorMessageUI = 0;
            fwhtrk.parentErrorCode = "";
            fwhtrk.childErrorCode = "";
        };
        this.dealsAndPromotionsModalClosed = function () {
            fwhtrk.page.virtualname = "";
            fwhtrk.event.promoDetails = 0;
            fwhtrk.event.startonlineorder = 0;
            fwhtrk.page.link = "";
        };
        this.pdplinks = function (link) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + link.toLowerCase();
            this.attemptTrack("pdp_toppings");
        };

        this.favCarousel = function (
            categoryName,
            prdNameWithSize = '',
            productId,
            itemPrice,
            quantity,
            addToBagSource,
            CartQuantity,
            pos,
            prdName,
            options,
            toastedData,
            isMiam,
            combo,
            CartCurrentItem
        ) {
            const soupSize = CartCurrentItem.analytics.isSoup ? `soups:${CartCurrentItem.analytics.Size}` : "n/a";
            var prdString = getReOrderCartProducts(
                categoryName,
                prdNameWithSize,
                quantity,
                itemPrice,
                addToBagSource,
                productId,
                null,
                prdName,
                options,
                combo,
                soupSize
            );

            fwhtrk.page.products = prdString.toLowerCase().replace(/evar/g, "eVar");
            if (toastedData) {
                fwhtrk.page.event.toasted = 1;
            }
            fwhtrk.page.event.upsellProductAdded = 1;
            fwhtrk.event.MIAMPriceAdded = 1;
            fwhtrk.event.ExtrasPriceAdded = 1;
            fwhtrk.event.itemaddedtobag = 1;
            fwhtrk.event.productPriceAdded = 1;
            fwhtrk.event.productQuantityAdded = 1;
            fwhtrk.cartID = orderViewModel.currentOrder.cartId;
            fwhtrk.event.upsellProductAdded = isMiamFvrt ? 1 : 0;
            fwhtrk.event.ComboPriceAdded = 1;
            this.cartOpen();
            if (fwhtrk.storeRegion == 'PR') {
                fwhtrk.event.CYO = 0;
            }
            this.attemptTrack("addToBag");
        };
        this.RemoveItemAndCheckout = function (
            categoryName,
            products,
            addtoBagSource,
            buttonText,
            modalname,
            currentItemResponse,
            isOrderAgain,
            isCalledFromReOrder
        ) {
            fwhtrk.event.itemAddedtoBag = 1;
            var toastedData = false;
            var isMiamFvrt = false;
            if (isCalledFromReOrder) {
                for (var i = 0; i < currentItemResponse.length; i++) {
                    if (currentItemResponse[i].options) {
                        if (currentItemResponse[i].options[1] && currentItemResponse[i].options[1].optionName == "Toasted") {
                            toastedData = true;
                        }
                    }
                    if (currentItemResponse[i].combo) {
                        isMiamFvrt = true;
                    }
                }
            }
            if (!isCalledFromReOrder) {
                for (var i = 0; i < currentItemResponse.length; i++) {
                    if (currentItemResponse[i].Options) {
                        if (currentItemResponse[i].Options[1] && currentItemResponse[i].Options[1].OptionName == "Toasted") {
                            toastedData = true;
                        }
                    }
                    if (currentItemResponse[i].Combo) {
                        isMiamFvrt = true;
                    }
                }
            }

            fwhtrk.page.event.toasted = toastedData ? 1 : 0;
            fwhtrk.page.event.upsellProductAdded = isMiamFvrt ? 1 : 0;
            fwhtrk.event.upsellProductAdded = isMiamFvrt ? 1 : 0;

            if (modalname) {
                fwhtrk.page.link =
                    getDomainName() + $("#dtmPageSection").val() +
                    "|" +
                    modalname +
                    " - " +
                    buttonText.trim().toLowerCase();
            } else {
                fwhtrk.page.link =
                    getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.trim().toLowerCase();
            }
            if (isCalledFromReOrder) {
                var productsString = getMultipleReOrderCartProducts(
                    products,
                    addtoBagSource,
                    products.analyticsCategoryName,
                    currentItemResponse,
                    isOrderAgain,
                    isCalledFromReOrder
                );
                fwhtrk.page.products = productsString.toLowerCase().replace(/evar/g, "eVar");
            }

            if (!isCalledFromReOrder) {
                var productsString = getMultipleReOrderCartProducts(
                    products,
                    addtoBagSource,
                    products.AnalyticsCategoryName,
                    currentItemResponse,
                    isOrderAgain,
                    isCalledFromReOrder
                );
                fwhtrk.page.products = productsString.toLowerCase().replace(/evar/g, "eVar");
            }

            fwhtrk.event.productPriceAdded = 1;
            fwhtrk.event.productQuantityAdded = 1;
            fwhtrk.event.MIAMPriceAdded = 1;
            fwhtrk.event.ExtrasPriceAdded = 1;
            fwhtrk.event.itemaddedtobag = 1;
            fwhtrk.event.ComboPriceAdded = 1;
            if (fwhtrk.storeRegion == 'PR') {
                fwhtrk.event.CYO = 0;
                fwhtrk.event.ComboPriceAdded = 1;
            }
        };
        this.pdpEditlinks = function (section, link, buttonTxt, editOption) {
            if (editOption !== undefined) {
                fwhtrk.page.link =
                    getDomainName() + $("#dtmPageSection").val() +
                    "|" +
                    buttonTxt +
                    ":" +
                    section +
                    ":" +
                    link.toLowerCase() +
                    ":" +
                    editOption.toLowerCase();
            } else {
                fwhtrk.page.link =
                    getDomainName() + $("#dtmPageSection").val() +
                    "|" +
                    buttonTxt +
                    ":" +
                    section +
                    ":" +
                    link.toLowerCase();
            }
            this.attemptTrack("edit_ingredient");
        };
        this.DBFavoritesOrBestsellers = function (favorbest) {
            fwhtrk.DBFavoritesOrBestsellers = favorbest;
        };
        this.sodiumPopUp = function (buttontext) {
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() + "|" + buttontext.toLowerCase().trim();
            this.attemptTrack("warning_cta");
        };
        this.sodiumWarningPopUp = function () {
            fwhtrk.page.virtualname =
                getDomainName() + $("#dtmPageName").val().toLowerCase() + ":" + "sodium warning modal";
            this.attemptTrack("modal_pageview");
        };
        this.openModalPopUp = function (name, bag) {
            fwhtrk.page.virtualname =
                getDomainName() + $("#dtmPageName").val().toLowerCase() + ":" + name;
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val().toLowerCase() + "|" + bag;
            fwhtrk.page.products = "n/a";
            fwhtrk.page.event.itemViewed = 0;
            this.attemptTrack("modal_pageview");
        };
        this.clearAllPDP = function () {
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val().toLowerCase() + "|" + "clear all";
            this.attemptTrack("pdp_ingredient_clear");
        };
        this.favoritesWarning = function (name) {
            fwhtrk.page.warningMessage = name.toLowerCase();
            fwhtrk.page.event.warningMessage = 1;
        };
        this.storeCloseFavoriteWarning = function (name) {
            fwhtrk.page.warningMessage = name.toLowerCase();
            fwhtrk.page.event.warningMessage = 1;
            fwhtrk.event.errorMessageUI = 1;
            fwhtrk.parentErrorCode = "n/a";
            fwhtrk.childErrorCode = "n/a";
        };
        this.locatorClick = function (buttontext) {
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() + "|" + buttontext.toLowerCase();
            this.attemptTrack("location_click_action");
        };
        this.deliveryLocatorClick = function (buttontext) {
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() + "|" + buttontext.toLowerCase();
            this.attemptTrack("location_delivery_click_action");
        };
        this.locatorWarning = function (message) {
            fwhtrk.page.warningMessage = message;
            fwhtrk.page.event.warningMessage = 1;
            this.attemptTrack("warning message");
        };
        this.locatorGetDirectionsClick = function (buttontext, storeId) {
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() + "|" + buttontext.toLowerCase();
            fwhtrk.page.event.storeGetDirections = 1;
            fwhtrk.storeID = storeId.LocationId.StoreNumber;
            this.attemptTrack("location_click_action");
        };
        this.storeDetailsAnalytics = function () {
            fwhtrk.page.virtualname =
                getDomainName() + $("#dtmPageName").val().toLowerCase() + ":" + "store details modal";
            fwhtrk.event.restaurantdetailsviewed = 1;
            fwhtrk.event.storeDetails = 1;
            this.attemptTrack("modal_pageview");
        };
        this.locatorPrevNextClick = function (buttontext) {
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() + "|" + buttontext.toLowerCase();
            fwhtrk.page.event.pickup = 1;
            this.attemptTrack("location_click_action");
        };
        this.miamPageLoad = function () {
            fwhtrk.page.event.miam = 1;
            fwhtrk.page.event.itemViewed = 0;
        };
        this.noThanksMiam = function (data) {
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val().toLowerCase() + "|" + data.toLowerCase();
        };
        this.miamApplyEdit = function (data) {
            this.noThanksMiam(data);
            this.clearErrorEvent(fwhtrk.event);
            this.attemptTrack("cart cta");
        };
        this.makeitamealUpsellProductAdded = function () {
            fwhtrk.event.upsellProductAdded = 1;
        };
        this.kidsMealCloseTrack = function () {
            fwhtrk.event.upsellProductAdded = 0;
            fwhtrk.page.link = getDomainName() + ":kids meal|" + "cancel";
            this.attemptTrack("meal_click_action");
        };
        this.locatorTextClick = function (buttontext, data, isMap) {
            if (isMap) {
                fwhtrk.storeSearchKeyword = "geo-selection";
                this.attemptTrack("storeSearchResults");
            } else {
                fwhtrk.page.link =
                    getDomainName() + $("#dtmPageSection").val() + "|" + buttontext.toLowerCase();
                fwhtrk.storeSearchKeyword = data;
                this.attemptTrack("location_click_action");
            }

        };
        this.makeitamealButton = function (data) {
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val().toLowerCase() + "|" + data.toLowerCase();
            this.attemptTrack("miam");
        };
        this.modalCheckOut = function (name) {

            if (isCurrentPage('home')) {
                this.attemptTrack('dashboard_click_action');
            } else if (isCurrentPage('menu')) {
                this.attemptTrack('menu_click_action');
            } else if (isCurrentPage('my-favorites')) {
                this.attemptTrack('account_click_action');
            }
            setTimeout(() => {
                fwhtrk.page.virtualname =
                    getDomainName() + $("#dtmPageName").val().toLowerCase() + ":" + name;
                this.attemptTrack("modal_pageview");
            }, 100)

        };
        this.storeCloseModalAnalytics = function (val) {
            fwhtrk.page.virtualname =
                getDomainName() + $("#dtmPageName").val().toLowerCase() + ":" + val;
            this.attemptTrack("modal_pageview");
        };
        this.favCarouselLinkCall = function (pos, prdName, favCatName) {
            fwhtrk.position = pos;
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() +
                "|" +
                favCatName +
                " " +
                prdName.toLowerCase();
            this.attemptTrack("dashboard_click_action");
        };
        this.favAccountLinkCall = function (prdName) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + "Favorites" + " " + prdName.toLowerCase();
            fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
        };
        this.favoriteCarouselClick = function (prdName) {
            fwhtrk.page.link = fwhtrk.page.section + "|" + "favorites" + " " + prdName.toLowerCase();
        }
        this.seeAllPDP = function (txt) {
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val().toLowerCase() + "|" + txt.toLowerCase();
            this.attemptTrack("PDP_click_action");
        };
        this.emptyPageLink = function (txt) {
            fwhtrk.page.link = "";
        };

        this.recentOrdersDismiss = function () {
            var dtmPageseleectionValue = getDomainName() + $("#dtmPageSection").val() || "";
            fwhtrk.page.link =
                dtmPageseleectionValue.toLowerCase().trim() +
                "|" +
                "tutorial overlay:dismiss";
            this.attemptTrack("dashboard_click_action");
        };

        // Analytics for Clear cart feature
        this.removeAllProducts = function (productsData = [], TotalPrice) {
            const productStringArray =
                productsData.length &&
                productsData.map((products) => {
                    const { categoryName, productName, price, quantity, categoryId, productId, options, combo, ProductOriginSource } = products;
                    return getCartProductsRemove(
                        categoryName,
                        productName,
                        productName,
                        parseFloat(price) * quantity,
                        quantity,
                        categoryId,
                        productId,
                        "",
                        false,
                        TotalPrice,
                        options,
                        combo,
                        ProductOriginSource
                    );
                });
            const productString = productStringArray.join(",");
            fwhtrk.page.products = productString.toLowerCase().replace(/evar/g, "eVar");
            fwhtrk.page.removedProduct = productString.toLowerCase().replace(/evar/g, "eVar");
            fwhtrk.page.link = `${$("#dtmPageSection")
                .val()
                .toLowerCase()}|clear cart`;
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
            fwhtrk.page.event.itemRemoved = 1;
            fwhtrk.event.productPriceRemove = 1;
            fwhtrk.event.productQuantityRemove = 1;
            fwhtrk.event.MIAMPriceRemove = 1;
            fwhtrk.event.ExtrasPriceRemove = 1;
            fwhtrk.event.itemRemoved = 1;
            fwhtrk.event.ComboPriceRemove = 1;
            this.attemptTrack("remove from cart");
        };

        // Analytics for Keep-shopping button
        this.keepShopping = function (buttontext, isReorder, attemptTrack) {
            this.clearErrorEvent(fwhtrk.event);
            fwhtrk.event.startonlineorder = 0;
            fwhtrk.reorder = 0;
            if (isReorder) {
                fwhtrk.page.link =
                    getDomainName() + $("#dtmPageSection").val() +
                    "|" +
                    "out of stock modal - " +
                    buttontext.toLowerCase();
                this.attemptTrack(attemptTrack);
            } else {
                fwhtrk.page.link =
                    getDomainName() + $("#dtmPageSection").val() + "|" + buttontext.toLowerCase();
                this.attemptTrack("cart cta");
            }
        };

        this.removeAndContinueCTAClick = function (cta) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|out of stock modal​ - " + cta;
            fwhtrk.event.productPriceRemove = 1;
            fwhtrk.event.productQuantityRemove = 1;
            fwhtrk.event.MIAMPriceRemove = 1;
            fwhtrk.event.ExtrasPriceRemove = 1;
            fwhtrk.event.itemremoved = 1;
            this.attemptTrack("remove from cart");
        };

        this.removeAndContinueModal = function () {
            fwhtrk.page.virtualname = '';
        };

        this.removeAndContinueModalOpen = function (unavailableContent = '') {
            fwhtrk.page.virtualname = getDomainName() + $("#dtmPageName").val() + ":out of stock modal​";
            if (unavailableContent) {
                fwhtrk.page.event.warningMessage = 1;
                fwhtrk.page.warningMessage = unavailableContent;
            }
            this.attemptTrack("modal_pageview");
        };

        this.outOfStockModal = function () {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|out of stock modal​ - " + "ok";
            fwhtrk.page.virtualname = '';
            this.attemptTrack("cart_click_action");
        };

        this.removeAndContinue = function (ctaText) {
            fwhtrk.page.name = getDomainName() + $("#dtmPageName").val() + ":out of stock modal​";
            fwhtrk.page.link = fwhtrk.page.section + "|" + ctaText.toLowerCase();
        }

        this.quickAddOns = function (
            prodName,
            totalCount,
            position,
            productId,
            categoryName,
            categoryId,
            price
        ) {
            fwhtrk.storeCountry =
                orderViewModel.store.storeCountry || this.fallbackCountry;
            fwhtrk.localTime = getLocalTime();
            fwhtrk.newrepeat = "new";
            fwhtrk.storeID = orderViewModel.store.id;

            var loyaltyId = $("#dtmLoyaltyId").val();
            var guestId = $("#dtmGuestID").val();

            if (isUserLoggedIn) {
                fwhtrk.user.guestID = guestId;
                fwhtrk.user.loyaltyID = loyaltyId;
                fwhtrk.loginStatus = "logged-in";
            } else {
                fwhtrk.user.guestID = "n/a";
                fwhtrk.user.loyaltyID = "n/a";
                fwhtrk.loginStatus = "logged-out";
            }
            fwhtrk.guestCountry =
                orderViewModel.Analytics.guestCountry || this.fallbackCountrys;
            fwhtrk.storeLanguage = orderViewModel.store.languageCode.substring(0, 2);
            fwhtrk.user.geoSelected = "yes";
            fwhtrk.user.mid = "n/a";
            fwhtrk.user.uxRendered = analytics.getScreenBreakpoint();
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
            fwhtrk.orderType = orderViewModel.AnalyticsorderType;
            fwhtrk.cartID = orderViewModel.currentOrder.cartId;
            fwhtrk.orderSourceType = orderViewModel.OrderSourceType;
            fwhtrk.position = totalCount + "|" + position;
            fwhtrk.event.itemaddedtobag = 1;
            fwhtrk.event.productPriceAdded = 1;
            fwhtrk.event.productQuantityAdded = 1;
            fwhtrk.page.event.toasted = 0;
            fwhtrk.event.ComboPriceAdded = 1;
            fwhtrk.event.MIAMPriceAdded = 1;
            fwhtrk.event.ExtrasPriceAdded = 1;
            fwhtrk.page.link = fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() +
                "|" +
                "quick add on:" +
                prodName.toLowerCase();
            var productString = getCartProductsRemove(
                categoryName,
                prodName,
                prodName,
                price,
                1,
                categoryId,
                productId,
                true,
                (quickAddon = true)
            );
            fwhtrk.products = productString.toLowerCase().replaceAll("evar", "eVar");
            fwhtrk.page.products = productString.toLowerCase().replaceAll("evar", "eVar");

            this.attemptTrack("addToBag");
        };

        this.emptyCartStateTrack = function () {
            fwhtrk.storeCountry =
                orderViewModel.store.storeCountry || this.fallbackCountry;
            fwhtrk.localTime = getLocalTime();
            fwhtrk.storeID = orderViewModel.store.id;
            var loyaltyId = $("#dtmLoyaltyId").val();
            var guestId = $("#dtmGuestID").val();
            if (isUserLoggedIn) {
                fwhtrk.user.guestID = guestId;
                fwhtrk.user.loyaltyID = loyaltyId;
                fwhtrk.loginStatus = "logged-in";
            } else {
                fwhtrk.user.guestID = "n/a";
                fwhtrk.user.loyaltyID = "n/a";
                fwhtrk.loginStatus = "logged-out";
            }
            fwhtrk.guestCountry =
                orderViewModel.Analytics.guestCountry || this.fallbackCountrys;
            if (orderViewModel.store.languageCode !== null) {
                fwhtrk.storeLanguage = orderViewModel.store.languageCode.substring(
                    0,
                    2
                );
            } else {
                fwhtrk.storeLanguage = this.fallbackLanguage;
            }
            fwhtrk.user.geoSelected = "yes";
            fwhtrk.user.uxRendered = analytics.getScreenBreakpoint();
            fwhtrk.orderType = orderViewModel.AnalyticsorderType;
            fwhtrk.page.section = getDomainName() + ":bag";
            fwhtrk.page.name = getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":empty bag";
            this.attemptTrack("PDP_Cart_PageView");
        };

        this.emptyCartActionTrack = function (message) {
            fwhtrk.storeCountry =
                orderViewModel.store.storeCountry || this.fallbackCountry;
            fwhtrk.localTime = getLocalTime();
            fwhtrk.storeID = orderViewModel.store.id;
            var loyaltyId = $("#dtmLoyaltyId").val();
            var guestId = $("#dtmGuestID").val();
            if (isUserLoggedIn) {
                fwhtrk.user.guestID = guestId;
                fwhtrk.user.loyaltyID = loyaltyId;
                fwhtrk.loginStatus = "logged-in";
            } else {
                fwhtrk.user.guestID = "n/a";
                fwhtrk.user.loyaltyID = "n/a";
                fwhtrk.loginStatus = "logged-out";
            }
            fwhtrk.guestCountry =
                orderViewModel.Analytics.guestCountry || this.fallbackCountrys;
            if (orderViewModel.store.languageCode !== null) {
                fwhtrk.storeLanguage = orderViewModel.store.languageCode.substring(
                    0,
                    2
                );
            } else {
                fwhtrk.storeLanguage = this.fallbackLanguage;
            }
            fwhtrk.user.geoSelected = "yes";
            fwhtrk.user.uxRendered = analytics.getScreenBreakpoint();
            fwhtrk.orderType = orderViewModel.AnalyticsorderType;
            fwhtrk.page.section = getDomainName() + ":bag";
            fwhtrk.page.name = getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":empty bag";
            fwhtrk.page.link = getDomainName() + ":bag" + "|" + message;
            this.attemptTrack("empty_cart_cta");
        };

        this.errorMessage = function (
            message,
            parentCode = "n/a",
            childErrorCode = "n/a",
            isMWError
        ) {
            fwhtrk.page.errorMessage = message;
            fwhtrk.errorMessage = message;
            fwhtrk.event.errormessage = 1;
            fwhtrk.page.event.errorMessage = 1;
            fwhtrk.parentErrorCode =
                parentCode.indexOf("DORD") >= 0 ? parentCode : "n/a";
            fwhtrk.childErrorCode =
                childErrorCode.indexOf("DORD") < 0 ? childErrorCode : "n/a";
            if (isMWError) fwhtrk.event.errorMessageMW = 1;
            else fwhtrk.event.errorMessageUI = 1;
            fwhtrk.page.virtualname =
                getDomainName() + $("#dtmPageName").val().toLowerCase() + ":" + "error warning modal";
            this.attemptTrack("errorMessage");
        };
        this.expandCollapse = function (page, message) {
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() + "|" + page + ":" + message;
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
            this.attemptTrack("recent_order_click_action");
        };

        this.offerStart = function (
            offerId,
            offertype,
            offerDescription,
            OfferTitle,
            countryLang,
            link,
            startOnlineOrder
        ) {
            fwhtrk.page.link = getDomainName() + ":my rewards" + "|" + link;
            fwhtrk.page.section = getDomainName() + ":my rewards";
            fwhtrk.page.name = countryLang + ":" + "my rewards:offers";
            fwhtrk.event.startonlineorder = startOnlineOrder;
            fwhtrk.offerDesc = offerDescription ? offerDescription : "n/a";
            fwhtrk.user.promo =
                offertype.toLowerCase() + "|" + OfferTitle.toLowerCase();
            fwhtrk.user.dealplu = offerId ? offerId : "n/a";
            this.attemptTrack("rewards_click_action");
        };

        this.offerCodePageLoad = function (
            OfferTitle,
            offerDescription,
            offerId,
            storeId,
            storeCountry,
            storeLanguage,
            offertype,
            countryLang
        ) {
            fwhtrk.storeCountry = storeCountry ? storeCountry : "n/a";
            fwhtrk.localTime = getLocalTime();
            fwhtrk.newrepeat = "new";
            fwhtrk.storeID = "n/a";
            fwhtrk.loginStatus = "logged-out";
            fwhtrk.guestCountry = "n/a";
            fwhtrk.storeLanguage = storeLanguage ? storeLanguage : "n/a";
            fwhtrk.user.geoSelected = "yes";
            fwhtrk.user.guestID = "n/a";
            fwhtrk.user.mid = "n/a";
            fwhtrk.user.uxRendered = analytics.getScreenBreakpoint();
            fwhtrk.user.loyaltyID = "n/a";
            fwhtrk.orderType = "n/a";
            fwhtrk.page.section = getDomainName() + ":my rewards";
            fwhtrk.page.name = countryLang.toLowerCase() + ":" + "my rewards:offers";
            fwhtrk.user.promo =
                offertype.toLowerCase() + "|" + OfferTitle.toLowerCase();
            fwhtrk.user.dealplu = offerId ? offerId : "n/a";
            fwhtrk.offerDesc = offerDescription ? offerDescription : "n/a";
        };

        this.cartOpen = () => {
            fwhtrk.page.event.cartOpen = 0;
            if (orderViewModel.cartOpen || !orderViewModel.currentOrder.cartId) {
                fwhtrk.page.event.cartOpen = 1;
                orderViewModel.cartOpen = false;
                orderViewModel.save();
            }
        };

        this.deleteAccount = function () {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + "delete account?";
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
            fwhtrk.page.event.attemptAccountToDelete = 1;
            this.attemptTrack("account_click_action");
        };
        this.openUpselllModal = function () {
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            fwhtrk.page.virtualname =
                getDomainName() + $("#dtmPageName").val().toLowerCase() + ":upsell modal";
            this.attemptTrack("modal_pageview");
        };
        this.upsellModalItemButtonClick = function (total, position, buttonText) {
            this.setGlobalValues();
            this.setStoreIsoCodes(orderViewModel.Analytics.guestCountry);
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + buttonText;
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            fwhtrk.page.virtualname =
                getDomainName() + $("#dtmPageName").val().toLowerCase() + ":upsell modal";
            fwhtrk.position = total + "|" + position;
            this.attemptTrack("PDP_click_action");
        };
        this.makeitamealContinue = function () {
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            fwhtrk.page.name =
                getDomainName() + $("#dtmPageName").val().toLowerCase() + ":select a drink";
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|continue";
            fwhtrk.page.event.drinkSelected = 1;
            this.attemptTrack("miam_click_action");
        };
        this.kidsMealContinue = function () {
            const locale = $("#scLanguageCode").val().toLowerCase();
            fwhtrk.page.section = "order:kids meal";
            fwhtrk.page.name = getDomainName() + ":" + locale + ":kids meal:select a drink";
            fwhtrk.page.link = getDomainName() + ":kids meal|continue";
            fwhtrk.page.event.drinkSelected = 1;
            this.attemptTrack("meal_click_action");
        };
        this.makeitamealPageload = function (pageName, continuecta) {
            var locale = $("#scLanguageCode").val().toLowerCase();
            if (isKidsMealProduct()) {
                let customPageName = continuecta ? "select side" : pageName;
                fwhtrk.page.name = getDomainName() + ":" + locale + ":kids meal:" + customPageName;
            } else {
                fwhtrk.page.name =
                    getDomainName() + $("#dtmPageName").val().toLowerCase() + ":" + pageName;
            }
            this.attemptTrack("meal_screen_view");
        };
        this.emptyVirtualName = function () {
            fwhtrk.page.virtualname = "";
        };
        this.recentOrderClickPickUp = function (recentTxt) {
            fwhtrk.page.link =
                getDomainName() + ":locator|pickup predictive search -" + " " + recentTxt;
            this.attemptTrack("locator");
        };

        this.defaultOrderType = function () {
            fwhtrk.orderType = orderViewModel.AnalyticsorderType || "In-Store Pickup";
        };
        this.pageLink = function (buttonText, link) {
            if (link) {
                fwhtrk.page.link =
                    getDomainName() + $("#dtmPageSection").val() +
                    "|" +
                    link +
                    ":" +
                    buttonText.toLowerCase();
            } else {
                fwhtrk.page.link =
                    getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.toLowerCase();
            }
        };
        this.pdp_meal_continue = function (buttonText) {
            fwhtrk.page.link =
                getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.toLowerCase();
            fwhtrk.page.event.kidsMealContinue = 1;
            this.attemptTrack("meal_click_action");
        };
        this.defaultStoreHeader = function () {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|header:default store";
            this.attemptTrack("subheader_click_action");
        };
        this.defaultStoreHeaderValues = function (storeId, orderType) {
            fwhtrk.storeID = storeId;
            fwhtrk.orderType = getOrderTypeByFulfillmentType(orderType);
        };
        this.cmsClickTrack = function (componentName, buttonText, buttonIdentifier, trackid, data, event) {
            let itemsInCartCount = orderViewModel.currentOrder.cartQuantity;
            fwhtrk.event.startonlineorder = 0;
            fwhtrk.event.disclaimer = 0;
            fwhtrk.reorder = 0;
            const buttonTitle = data ? data.toLowerCase() + ':' : '';

            fwhtrk.page.link = fwhtrk.page.section + '|' + componentName + ':' + buttonTitle + buttonText.toLowerCase();

            const dataset = event && event.currentTarget && event.currentTarget.dataset || '';

            if (dataset && dataset.componentfaqtitle) {
                const { componentfaqtitle } = event.currentTarget.dataset;
                if (buttonIdentifier == "accordion") {
                    fwhtrk.faqTitle = componentfaqtitle;
                    fwhtrk.page.link = fwhtrk.page.section + '|' + componentName + ':' + buttonText.toLowerCase();
                }
            }
            if (componentName == 'footer' && buttonIdentifier == 'start order') {
                fwhtrk.event.startonlineorder = 1
            }
            if (buttonText.toLowerCase() == 'order now' || buttonText.toLowerCase() == 'start order' || buttonText.toLowerCase() == 'shop deal') {
                fwhtrk.event.startonlineorder = 1
            }
            if (componentName == 'how_it_works' && buttonIdentifier == 'view my rewards') {
                fwhtrk.event.viewRewards = 1;
            }
            if(itemsInCartCount > 0 && componentName == 'footer' && buttonIdentifier == 'start order') {
                fwhtrk.event.startonlineorder = 0
                fwhtrk.page.link = `${fwhtrk.page.section}|${componentName}:view bag`;
            }
            for (const property in dataset) {
                if (property !== 'buttontext') {
                    fwhtrk.event[property] = dataset[property]
                }
            }

            if ($("#isUserLoggedIn").val() && componentName == 'promotion') {
                if (buttonIdentifier == 'shop deal') {
                    fwhtrk.page.link = fwhtrk.page.section + '|promotion' + ':' + buttonIdentifier;
                    fwhtrk.event.promoPrimaryCTAClick = 1;
                    fwhtrk.user.promo = 'n/a';
                    fwhtrk.offerDesc = 'n/a';
                    fwhtrk.user.dealplu = 'n/a';
                }
                else {
                    fwhtrk.page.link = fwhtrk.page.section + '|promotion' + ':' + 'learn more';
                }
            }

            if (trackid) {
                this.attemptTrack(trackid);
            } else {
                this.attemptTrack(componentName + '_click_action');
            }
        };

        this.nutritionModal = function (isModal) {
            if (isModal) {
                var pageName = getDomainName() + (document.getElementById("dtmPageName") && document.getElementById("dtmPageName").value.toLowerCase() || "")
                fwhtrk.page.virtualname = pageName + ":nutrition calculator modal";
                this.attemptTrack("nutrition_calc_modalView");
            } else {
                fwhtrk.page.virtualname = "";
            }

        }

        this.onClickNutritionModal = function (text) {
            fwhtrk.page.link = fwhtrk.page.section + "|" + text.toLowerCase();
            this.attemptTrack("nutrition_calc_click_action");
        }
        this.deliveryToAddressClick = function (buttonText) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.trim().toLowerCase();
            fwhtrk.event.delivery = 1;
            fwhtrk.event.restaurantSelected = 1;
            fwhtrk.event.deliverySearch = 0;
            this.attemptTrack("location_delivery_click_action");
        }
        this.deliveryAddressSelection = function () {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|delivery:predictive store search";
            fwhtrk.event.deliverySearch = 1;
            this.attemptTrack("location_delivery_click_action");
            this.attemptTrack("modal_pageview");
        }
        this.pickupMapSelection = function () {
            fwhtrk.storeSearchKeyword = "geo-selection";
            this.attemptTrack("storeSearchResults");
        }
        this.viewOrderHistoryClick = function (ctaText) {
            fwhtrk.page.link = fwhtrk.page.section + "|" + ctaText.toLowerCase();
            this.attemptTrack('dashboard_click_action');
        }
        this.viewAllCta = function (ctaText) {
            fwhtrk.page.link = fwhtrk.page.section + "|" + ctaText.toLowerCase();
            this.attemptTrack('dashboard_click_action');
        }
        this.switchLocation = function (attemptTrack) {
            fwhtrk.page.link = fwhtrk.page.section + "|" + "out of stock modal - switch location";
            analytics.attemptTrack(attemptTrack);
        }
        this.categoryPageAction = function (button_text) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|category tab:" + button_text;
            fwhtrk.page.product.subCategory = button_text;
            this.attemptTrack("category_tab_click_action");
        };

        this.prPDPPageLoad = function (categoryName, product) {
            this.setGlobalValues();
            const productName = formatProductName(product)
            fwhtrk.page.name = getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":product details";
            fwhtrk.page.section = getDomainName() + ':product details';
            fwhtrk.page.product.category = [categoryName];
            fwhtrk.page.products = categoryName && categoryName.toLowerCase() + ";" + productName.toLowerCase();
            fwhtrk.page.event.itemViewed = 1
            this.attemptTrack("PDP_Cart_PageView");
        }

        this.prDrinksPageLoad = function () {
            fwhtrk.page.virtualname = ''
            fwhtrk.page.section = getDomainName() + ":make it a combo"
            fwhtrk.page.name = getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":make it a combo:drink"
            this.attemptTrack("combo_screen_view")
        }

        this.prSidesPageLoad = function (sideName) {
            fwhtrk.page.section = getDomainName() + ':make it a combo'
            const side = sideName && sideName.includes('Complemento') ? sideName.replace('Complemento', 'side') : sideName
            fwhtrk.page.name = getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":make it a combo:" + side.toLowerCase()
            this.attemptTrack("combo_screen_view")
        }

        this.clickContinue = function (category, sideName) {
            fwhtrk.page.section = getDomainName() + ':make it a combo'
            fwhtrk.page.link = getDomainName() + ':make it a combo|continue'
            const side = category && category.includes('Complemento') ? category.replace('Complemento', 'side') : category
            if (category == "Drink" || category == "Bebida") {
                fwhtrk.page.event.drinkSelected = 1
                fwhtrk.page.name = getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":make it a combo:drink"
            } else {
                fwhtrk.page.name = getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":make it a combo:" + side.toLowerCase()
            }
            this.attemptTrack("combo_click_action");

            setTimeout(() => {
                this.prSidesPageLoad(sideName)
            }, 1000)
        }

        this.prAddToBag = function (productString, isItemCustomized, isToasted, isCombo, isUpsell, sideName, isEditMode, isCloseClicked, buttonText, comboPriceUpdateEvent) {
            const side = sideName && sideName.includes('Complemento') ? sideName.replace('Complemento', 'side') : sideName
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val()

            // Clicking outside upsell Modal
            if (!isEditMode) {
                fwhtrk.page.name = getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":product details"
                fwhtrk.page.virtualname = getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":product details" + ":upsell modal";
                fwhtrk.page.link = getDomainName() + ':product details|cancel'
            }


            // Upsell Modal - No Thanks/Done
            if (buttonText && buttonText != 'add to cart') {
                //fwhtrk.page.virtualname = "order:" + $("#scLanguageCode").val().toLowerCase() + ":product details" + ":upsell modal";
                fwhtrk.position = "";
                fwhtrk.page.link = getDomainName() + ':product details|' + buttonText.toLowerCase()
            }

            // Combo Page Close Button
            if (isCloseClicked) {
                fwhtrk.page.virtualname = ''
                fwhtrk.page.name = getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":make it a combo:drink"
                //fwhtrk.page.link = 'order:product details|cancel'
            }

            // Completing Combo Flow
            if (isCombo) {
                fwhtrk.page.virtualname = ''
                fwhtrk.page.name = getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":make it a combo:" + (side ? side.toLowerCase() : "sides")
                fwhtrk.page.link = getDomainName() + ':make it a combo|add to cart'
                fwhtrk.page.section = getDomainName() + ':make it a combo'
            }

            fwhtrk.event.ComboPriceAdded = 1
            fwhtrk.page.event.toasted = isToasted ? 1 : 0
            fwhtrk.event.upsellProductAdded = isUpsell ? 1 : 0
            fwhtrk.page.event.cartOpen = 0
            fwhtrk.page.products = productString
            fwhtrk.event.sandwichCustomized = isItemCustomized ? 1 : 0
            fwhtrk.event.CYO = 0
            fwhtrk.orderSourceType = 'regular'
            if (orderViewModel.cartOpen || !orderViewModel.currentOrder.cartId) {
                fwhtrk.page.event.cartOpen = 1;
                orderViewModel.cartOpen = false;
                orderViewModel.save();
            }
            if (isEditMode) {
                fwhtrk.page.link = buttonText == 'add to cart' ? getDomainName() + ':product details|' + buttonText.toLowerCase() : getDomainName() + ':product details|update'
                fwhtrk.event.productPriceUpdate = 1
                fwhtrk.event.productQuantityUpdate = 1
                fwhtrk.event.MIAMPriceUpdate = 1
                fwhtrk.event.ExtrasPriceUpdate = 1
                fwhtrk.event.updateCart = 1
                fwhtrk.page.event.MIAMSelected = 0
                fwhtrk.event.ComboPriceUpdate = 1
            } else {
                fwhtrk.event.productPriceAdded = 1
                fwhtrk.event.productQuantityAdded = 1
                fwhtrk.event.MIAMPriceAdded = 1
                fwhtrk.event.ExtrasPriceAdded = 1
                fwhtrk.event.itemaddedtobag = 1;
            }
            this.attemptTrack(isEditMode ? "updateToCart" : 'addToBag');
        }

        this.prOpenUpsellModal = function (source) {
            this.setGlobalValues();
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            setTimeout(() => {
                if (source == 'cart') {
                    fwhtrk.page.virtualname = getDomainName() + $("#dtmPageName").val().toLowerCase() + ":upsell modal";
                } else {
                    fwhtrk.page.virtualname =
                        getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":product details" + ":upsell modal";
                }
                this.attemptTrack("modal_pageview");
            }, 500)

        };
        this.prUpsellModalItemButtonClick = function (buttonText, total, position, source) {
            this.setGlobalValues();
            this.setStoreIsoCodes(orderViewModel.Analytics.guestCountry);
            setTimeout(() => {
                fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.toLowerCase();
                fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
                fwhtrk.page.virtualname = getDomainName() + ":" + $("#scLanguageCode").val().toLowerCase() + ":product details" + ":upsell modal";
                fwhtrk.position = ''
                if (total) {
                    fwhtrk.position = total + "|" + position;
                }

                if (source == 'cart') {
                    fwhtrk.page.virtualname = getDomainName() + $("#dtmPageName").val().toLowerCase() + ":upsell modal";
                    this.attemptTrack("cart cta");
                } else {
                    this.attemptTrack("PDP_click_action");
                }
            }, 500)
        };

        this.prCartApplyCombo = function (buttonText) {
            this.setGlobalValues();
            fwhtrk.page.name = getDomainName() + $("#dtmPageName").val().toLowerCase();
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + buttonText.toLowerCase();
            fwhtrk.page.section = getDomainName() + $("#dtmPageSection").val().toLowerCase();
            this.attemptTrack("cart cta");
        }

        this.saveProfileInfo = function (emailSaveProfile, loyaltyOptinSaveProfile) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + "save changes";
            fwhtrk.user.loyaltyActiveFlag = loyaltyOptinSaveProfile;
            fwhtrk.user.emailOptIn = orderViewModel.EmailOptInProfile;
            this.attemptTrack("profile_update_click_action");
        };

        this.contactInfoPageLoad = function () {
            fwhtrk.user.emailOptIn = orderViewModel.EmailOptInProfile && orderViewModel.EmailOptInProfile.toLowerCase();
            fwhtrk.user.loyaltyActiveFlag = orderViewModel.LoyaltyOption && orderViewModel.LoyaltyOption.toLowerCase();
        }

        this.rewardsPageView = function () {
            this.attemptTrack('profile_pageview')
        }
        this.rewardHistoryCTA_Click = function (btnCTA) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + btnCTA
            this.attemptTrack('rewards_cta_click_action')
        }
        this.rewardHistoryModal = function () {
            fwhtrk.page.virtualname = fwhtrk.page.name + ":rewards history modal";
            this.attemptTrack('modal_pageview')
        }
        this.rewardHistoryModal_insideCTA = function (btnCTA) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + btnCTA;
            fwhtrk.page.virtualname = fwhtrk.page.name + ":rewards history modal";
            this.attemptTrack('rewards-history_click_action')
        }
        this.rewardsCardButtonClick = function (btnCTA, offerDetails, cardIndex, storeSelector) {
            const text = ["Bonus", "Non Bonus", "Non S&D"];
            fwhtrk.user.promo = offerDetails.cardType && offerDetails.cardType.toLowerCase() + "|" + offerDetails.titleDisplayText.toLowerCase();
            fwhtrk.offerDesc = offerDetails.descriptionDisplayText && offerDetails.descriptionDisplayText.toLowerCase();
            fwhtrk.user.dealplu = offerDetails.id && offerDetails.id;
            fwhtrk.position = cardIndex && cardIndex;
            fwhtrk.event.promoPrimaryCTAClick = 1;
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + btnCTA.toLowerCase();
            if ((text.includes(offerDetails.cardType)) && storeSelector) {
                fwhtrk.event.startonlineorder = 1;
            }
            this.attemptTrack('rewards_primary_click_action');
        };
        this.bannerNotificationAnalytics = function (message) {
            fwhtrk.bannerMessage = message.toLowerCase();
            fwhtrk.event.bannerImpression = 1;
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|" + "header:banner impression";
            this.attemptTrack("banner_notification_impression");
        };
        this.bannerProductAddedAnalytics = function (offerDetails, comboData) {
            fwhtrk.rewardName = comboData.name.toLowerCase();
            fwhtrk.event.dealApplied = 1;
            fwhtrk.user.promo = offerDetails && offerDetails.cardType.toLowerCase() + "|" + offerDetails.descriptionDisplayText.toLowerCase();
            fwhtrk.offerDesc = offerDetails && offerDetails.descriptionDisplayText.toLowerCase();
            fwhtrk.user.dealplu = offerDetails && offerDetails.id;
        }
        this.removeVirtualName = function () {
            fwhtrk.page.virtualname = "";
        };
        this.upSellModalAnalytics = function () {
            fwhtrk.page.virtualname = fwhtrk.page.name + ":" + "redeem item modal";
            this.attemptTrack("modal_pageview");
        };
        this.modalCloseAnalytics = function () {
            fwhtrk.page.virtualname = "";
        };
        this.upsellModalAddtoBagClick = function (selectedProduct, offerDetails, orderViewModel) {
            fwhtrk.rewardName = selectedProduct.name.toLowerCase();
            fwhtrk.event.rewardItemAdded = 1;
            fwhtrk.user.promo = offerDetails && offerDetails.cardType.toLowerCase() + "|" + offerDetails.titleDisplayText.toLowerCase();
            fwhtrk.offerDesc = offerDetails.descriptionDisplayText && offerDetails.descriptionDisplayText.toLowerCase();
            fwhtrk.user.dealplu = offerDetails.id && offerDetails.id;
            fwhtrk.cartID = orderViewModel.currentOrder.cartId;
            fwhtrk.event.productPriceAdded = 1;
            fwhtrk.event.productQuantityAdded = 1;
            fwhtrk.event.MIAMPriceAdded = 1;
            fwhtrk.event.ExtrasPriceAdded = 1;
            fwhtrk.event.ComboPriceAdded = 1;
            fwhtrk.event.itemaddedtobag = 1;
            this.cartOpen();
            fwhtrk.page.virtualname = fwhtrk.page.name + ":" + "redeem item modal";
            orderViewModel.OrderSourceType = window.location.href.includes('rewards-activity') ? 'rewards' : 'deals';
            orderViewModel.save();
            let productsString = getReOrderCartProducts(
                selectedProduct.categoryName,
                selectedProduct.name,
                1,
                selectedProduct.price,
                addToBagSource = window.location.href.includes('rewards-activity') ? 'rewards' : 'deals',
                selectedProduct.productId,
                selectedProduct.categoryID,
                prdSizeName = ''
            )
            fwhtrk.products = productsString.toLowerCase().replace(/evar/g, "eVar");
            this.attemptTrack("reward_addToBag");
        };
        this.setTierLevel = function (tierLevel) {
            fwhtrk.user.tierLevel = tierLevel && tierLevel.toLowerCase();
        };
        this.dashboardNotificationModal = function (titleName) {
            fwhtrk.page.virtualname = fwhtrk.page.name + ":" + titleName;
            this.attemptTrack('modal_pageview')
        }
        this.dashboardNotificationClick = function (sectionName, buttonText) {
            fwhtrk.page.link = fwhtrk.page.section + "|" + sectionName + ":" + buttonText;
            fwhtrk.event.viewRewards = buttonText === "view rewards" ? 1 : 0;
            fwhtrk.event.startonlineorder = buttonText === "start order" ? 1 : 0;;
            this.attemptTrack('modal_cta_click_action')
        }
        this.updatePhoneNumberPopup = function () {
            fwhtrk.page.virtualname = fwhtrk.page.name + ':missing info modal';
            this.attemptTrack("modal_pageview")
        }
        this.updateProfileClick = function (buttonText) {
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|missing info:" + buttonText;
            fwhtrk.page.virtualname = fwhtrk.page.name + ':missing info modal';
            this.attemptTrack("modal_cta_click_action")
        }
        this.myRewardsCTAClickAction = function (tierData) {
            fwhtrk.user.tierLevel = tierData.toLowerCase();
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|my rewards";
            fwhtrk.event.viewRewards = 1;
            this.attemptTrack("dashboard_click_action");
        }

        this.onboardingScreen = function (tierData, title) {
            fwhtrk.user.tierLevel = tierData.toLowerCase()
            fwhtrk.page.virtualname = fwhtrk.page.name + ':' + title.replace(",", "").toLowerCase();
            this.attemptTrack('onboarding_modalView')
        }
        this.onboardingScreenCurrSlide = function (title) {
            fwhtrk.page.virtualname = fwhtrk.page.name + ':' + title.replace(",", "").toLowerCase();
            this.attemptTrack('onboarding_modalView')
        }
        this.onboardingScreenClose = function (tierData, title) {
            fwhtrk.user.tierLevel = tierData.toLowerCase()
            fwhtrk.page.link = getDomainName() + $("#dtmPageSection").val() + "|dismiss";
            fwhtrk.page.virtualname = fwhtrk.page.name + ':' + title.replace(",", "").toLowerCase();
            this.attemptTrack('onboarding_modal_cta_click_action')
        }

        this.downloadAppCall = function () {
            this.attemptTrack("download-click_action");
        };
        this.errorPageClick = function (buttontext = '') {
            fwhtrk.page.link = fwhtrk.page.section + "|" + buttontext.toLowerCase();
            this.attemptTrack("errorPage_clickAction")
        }
        this.fraudPopupAnaytics = function () {
          fwhtrk.page.virtualname = fwhtrk.page.name + ":" + "loyalty fraud modal";
          this.attemptTrack("loyaltyFraudModal_pageView");
        };
        this.fraudClickAction = function (isGuestCare, isSignout) {
          if (isGuestCare) {
            fwhtrk.event.contactUs = 1;
            fwhtrk.page.link  = fwhtrk.page.section +"|" +'contact guest care';
          }
          if (isSignout) {
            fwhtrk.event.loggedOut = 1;
            fwhtrk.page.link  = fwhtrk.page.section +"|" + 'sign out';
          }
          fwhtrk.page.virtualname = fwhtrk.page.name + ":" + "loyalty fraud modal";
          this.attemptTrack("loyaltyFraudModal_CTA_clickAction");
        };
    };

    var analytics = new Analytics();
    setTimeout(function () {
        analytics.setGlobalValues();
    }, 1000)

} catch (e) {
    void 0;
}


function getOrderTypeByFulfillmentType(fulfillmentType) {
    switch (fulfillmentType) {
        case "pickup":
            return "In-Store Pickup";
        case "delivery":
            return "Delivery";
        case "curbside":
            return "Curbside Pickup";
        default:
            return "n/a";
    }
}

function getExtrasPrice(options, fromPDP = false) {
    let price = 0;
    options && options.forEach((itr) => {
        if (fromPDP) {
            price = price + parseFloat(itr.price)
        } else {
            if (itr.modifierGrpId == 'Extra' || itr.ModifierGrpId == 'Extra') {
                price = price + (itr.price || itr.Price || itr.UnitPrice)
            }
        }
    })

    return price ? parseFloat(price).toFixed(2) : 0
}

const getComboPrice = (combo, quantity = 1) =>
(combo && (combo.ComboItems || combo.items || combo.Components) ?
    (((combo.BundledPrice || combo.bundledPrice || combo.MealCurrentPrice) +
        getUpchargePrice(combo.ComboItems || combo.items || combo.Components)) * quantity).toFixed(2) : '0');


const getOptionsPrice = (options, quantity) =>
    (options ? (getExtrasPrice(options) * quantity).toFixed(2) : '0');

const getComboString = combo =>
    getSelectedSideDrinkNames(combo && (combo.ComboItems || combo.items || combo.Components) ? (combo.ComboItems || combo.items || combo.Components) : []);

